(function(module) {
    'use strict';

    const STATIONS = [
        {
            "name": "Abbey Wood",
            "value": "ABW"
        },
        {
            "name": "Aber",
            "value": "ABE"
        },
        {
            "name": "Abercynon",
            "value": "ACY"
        },
        {
            "name": "Aberdare",
            "value": "ABA"
        },
        {
            "name": "Aberdeen",
            "value": "ABD"
        },
        {
            "name": "Aberdour",
            "value": "AUR"
        },
        {
            "name": "Aberdovey",
            "value": "AVY"
        },
        {
            "name": "Abererch",
            "value": "ABH"
        },
        {
            "name": "Abergavenny",
            "value": "AGV"
        },
        {
            "name": "Abergele & Pensarn",
            "value": "AGL"
        },
        {
            "name": "Aberystwyth",
            "value": "AYW"
        },
        {
            "name": "Accrington",
            "value": "ACR"
        },
        {
            "name": "Achanalt",
            "value": "AAT"
        },
        {
            "name": "Achnasheen",
            "value": "ACN"
        },
        {
            "name": "Achnashellach",
            "value": "ACH"
        },
        {
            "name": "Acklington",
            "value": "ACK"
        },
        {
            "name": "Acle",
            "value": "ACL"
        },
        {
            "name": "Acocks Green",
            "value": "ACG"
        },
        {
            "name": "Acton Bridge (Cheshire)",
            "value": "ACB"
        },
        {
            "name": "Acton Central",
            "value": "ACC"
        },
        {
            "name": "Acton Main Line",
            "value": "AML"
        },
        {
            "name": "Adderley Park",
            "value": "ADD"
        },
        {
            "name": "Addiewell",
            "value": "ADW"
        },
        {
            "name": "Addlestone",
            "value": "ASN"
        },
        {
            "name": "Adisham",
            "value": "ADM"
        },
        {
            "name": "Adlington (Cheshire)",
            "value": "ADC"
        },
        {
            "name": "Adlington (Lancs)",
            "value": "ADL"
        },
        {
            "name": "Adwick",
            "value": "AWK"
        },
        {
            "name": "Aigburth",
            "value": "AIG"
        },
        {
            "name": "Ainsdale",
            "value": "ANS"
        },
        {
            "name": "Aintree",
            "value": "AIN"
        },
        {
            "name": "Airbles",
            "value": "AIR"
        },
        {
            "name": "Airdrie",
            "value": "ADR"
        },
        {
            "name": "Albany Park",
            "value": "AYP"
        },
        {
            "name": "Albrighton",
            "value": "ALB"
        },
        {
            "name": "Alderley Edge",
            "value": "ALD"
        },
        {
            "name": "Aldermaston",
            "value": "AMT"
        },
        {
            "name": "Aldershot",
            "value": "AHT"
        },
        {
            "name": "Aldrington",
            "value": "AGT"
        },
        {
            "name": "Alexandra Palace",
            "value": "AAP"
        },
        {
            "name": "Alexandra Parade",
            "value": "AXP"
        },
        {
            "name": "Alexandria",
            "value": "ALX"
        },
        {
            "name": "Alfreton",
            "value": "ALF"
        },
        {
            "name": "Allens West",
            "value": "ALW"
        },
        {
            "name": "Alloa",
            "value": "ALO"
        },
        {
            "name": "Alness",
            "value": "ASS"
        },
        {
            "name": "Alnmouth",
            "value": "ALM"
        },
        {
            "name": "Alresford (Essex)",
            "value": "ALR"
        },
        {
            "name": "Alsager",
            "value": "ASG"
        },
        {
            "name": "Althorne (Essex)",
            "value": "ALN"
        },
        {
            "name": "Althorpe",
            "value": "ALP"
        },
        {
            "name": "Altnabreac",
            "value": "ABC"
        },
        {
            "name": "Alton",
            "value": "AON"
        },
        {
            "name": "Altrincham",
            "value": "ALT"
        },
        {
            "name": "Alvechurch",
            "value": "ALV"
        },
        {
            "name": "Ambergate",
            "value": "AMB"
        },
        {
            "name": "Amberley",
            "value": "AMY"
        },
        {
            "name": "Amersham",
            "value": "AMR"
        },
        {
            "name": "Ammanford",
            "value": "AMF"
        },
        {
            "name": "Ancaster",
            "value": "ANC"
        },
        {
            "name": "Anderston",
            "value": "AND"
        },
        {
            "name": "Andover",
            "value": "ADV"
        },
        {
            "name": "Anerley",
            "value": "ANZ"
        },
        {
            "name": "Angmering",
            "value": "ANG"
        },
        {
            "name": "Annan",
            "value": "ANN"
        },
        {
            "name": "Anniesland",
            "value": "ANL"
        },
        {
            "name": "Ansdell & Fairhaven",
            "value": "AFV"
        },
        {
            "name": "Apperley Bridge",
            "value": "APY"
        },
        {
            "name": "Appleby",
            "value": "APP"
        },
        {
            "name": "Appledore (Kent)",
            "value": "APD"
        },
        {
            "name": "Appleford",
            "value": "APF"
        },
        {
            "name": "Appley Bridge",
            "value": "APB"
        },
        {
            "name": "Apsley",
            "value": "APS"
        },
        {
            "name": "Arbroath",
            "value": "ARB"
        },
        {
            "name": "Ardgay",
            "value": "ARD"
        },
        {
            "name": "Ardlui",
            "value": "AUI"
        },
        {
            "name": "Ardrossan Harbour",
            "value": "ADS"
        },
        {
            "name": "Ardrossan South Beach",
            "value": "ASB"
        },
        {
            "name": "Ardrossan Town",
            "value": "ADN"
        },
        {
            "name": "Ardwick",
            "value": "ADK"
        },
        {
            "name": "Argyle Street",
            "value": "AGS"
        },
        {
            "name": "Arisaig",
            "value": "ARG"
        },
        {
            "name": "Arlesey",
            "value": "ARL"
        },
        {
            "name": "Armadale (West Lothian)",
            "value": "ARM"
        },
        {
            "name": "Armathwaite",
            "value": "AWT"
        },
        {
            "name": "Arnside",
            "value": "ARN"
        },
        {
            "name": "Arram",
            "value": "ARR"
        },
        {
            "name": "Arrochar & Tarbet",
            "value": "ART"
        },
        {
            "name": "Arundel",
            "value": "ARU"
        },
        {
            "name": "Ascot (Berks)",
            "value": "ACT"
        },
        {
            "name": "Ascott-under-Wychwood",
            "value": "AUW"
        },
        {
            "name": "Ash",
            "value": "ASH"
        },
        {
            "name": "Ash Vale",
            "value": "AHV"
        },
        {
            "name": "Ashburys",
            "value": "ABY"
        },
        {
            "name": "Ashchurch for Tewkesbury",
            "value": "ASC"
        },
        {
            "name": "Ashfield",
            "value": "ASF"
        },
        {
            "name": "Ashford (Surrey)",
            "value": "AFS"
        },
        {
            "name": "Ashford International",
            "value": "AFK"
        },
        {
            "name": "Ashford International (Eurostar)",
            "value": "ASI"
        },
        {
            "name": "Ashley",
            "value": "ASY"
        },
        {
            "name": "Ashtead",
            "value": "AHD"
        },
        {
            "name": "Ashton-under-Lyne",
            "value": "AHN"
        },
        {
            "name": "Ashurst (Kent)",
            "value": "AHS"
        },
        {
            "name": "Ashurst New Forest",
            "value": "ANF"
        },
        {
            "name": "Ashwell & Morden",
            "value": "AWM"
        },
        {
            "name": "Askam",
            "value": "ASK"
        },
        {
            "name": "Aslockton",
            "value": "ALK"
        },
        {
            "name": "Aspatria",
            "value": "ASP"
        },
        {
            "name": "Aspley Guise",
            "value": "APG"
        },
        {
            "name": "Aston",
            "value": "AST"
        },
        {
            "name": "Atherstone",
            "value": "ATH"
        },
        {
            "name": "Atherton",
            "value": "ATN"
        },
        {
            "name": "Attadale",
            "value": "ATT"
        },
        {
            "name": "Attenborough",
            "value": "ATB"
        },
        {
            "name": "Attleborough",
            "value": "ATL"
        },
        {
            "name": "Auchinleck",
            "value": "AUK"
        },
        {
            "name": "Audley End",
            "value": "AUD"
        },
        {
            "name": "Aughton Park",
            "value": "AUG"
        },
        {
            "name": "Aviemore",
            "value": "AVM"
        },
        {
            "name": "Avoncliff",
            "value": "AVF"
        },
        {
            "name": "Avonmouth",
            "value": "AVN"
        },
        {
            "name": "Axminster",
            "value": "AXM"
        },
        {
            "name": "Aylesbury",
            "value": "AYS"
        },
        {
            "name": "Aylesbury Vale Parkway",
            "value": "AVP"
        },
        {
            "name": "Aylesford",
            "value": "AYL"
        },
        {
            "name": "Aylesham",
            "value": "AYH"
        },
        {
            "name": "Ayr",
            "value": "AYR"
        },
        {
            "name": "Bache",
            "value": "BAC"
        },
        {
            "name": "Baglan",
            "value": "BAJ"
        },
        {
            "name": "Bagshot",
            "value": "BAG"
        },
        {
            "name": "Baildon",
            "value": "BLD"
        },
        {
            "name": "Baillieston",
            "value": "BIO"
        },
        {
            "name": "Balcombe",
            "value": "BAB"
        },
        {
            "name": "Baldock",
            "value": "BDK"
        },
        {
            "name": "Balham",
            "value": "BAL"
        },
        {
            "name": "Balloch",
            "value": "BHC"
        },
        {
            "name": "Balmossie",
            "value": "BSI"
        },
        {
            "name": "Bamber Bridge",
            "value": "BMB"
        },
        {
            "name": "Bamford",
            "value": "BAM"
        },
        {
            "name": "Banavie",
            "value": "BNV"
        },
        {
            "name": "Banbury",
            "value": "BAN"
        },
        {
            "name": "Bangor (Gwynedd)",
            "value": "BNG"
        },
        {
            "name": "Bank Hall",
            "value": "BAH"
        },
        {
            "name": "Banstead",
            "value": "BAD"
        },
        {
            "name": "Barassie",
            "value": "BSS"
        },
        {
            "name": "Barbican",
            "value": "ZBB"
        },
        {
            "name": "Bardon Mill",
            "value": "BLL"
        },
        {
            "name": "Bare Lane",
            "value": "BAR"
        },
        {
            "name": "Bargeddie",
            "value": "BGI"
        },
        {
            "name": "Bargoed",
            "value": "BGD"
        },
        {
            "name": "Barking",
            "value": "BKG"
        },
        {
            "name": "Barlaston",
            "value": "BRT"
        },
        {
            "name": "Barming",
            "value": "BMG"
        },
        {
            "name": "Barmouth",
            "value": "BRM"
        },
        {
            "name": "Barnehurst",
            "value": "BNH"
        },
        {
            "name": "Barnes",
            "value": "BNS"
        },
        {
            "name": "Barnes Bridge",
            "value": "BNI"
        },
        {
            "name": "Barnetby",
            "value": "BTB"
        },
        {
            "name": "Barnham",
            "value": "BAA"
        },
        {
            "name": "Barnhill",
            "value": "BNL"
        },
        {
            "name": "Barnsley",
            "value": "BNY"
        },
        {
            "name": "Barnstaple",
            "value": "BNP"
        },
        {
            "name": "Barnt Green",
            "value": "BTG"
        },
        {
            "name": "Barrhead",
            "value": "BRR"
        },
        {
            "name": "Barrhill",
            "value": "BRL"
        },
        {
            "name": "Barrow Haven",
            "value": "BAV"
        },
        {
            "name": "Barrow-in-Furness",
            "value": "BIF"
        },
        {
            "name": "Barrow-Upon-Soar",
            "value": "BWS"
        },
        {
            "name": "Barry",
            "value": "BRY"
        },
        {
            "name": "Barry Docks",
            "value": "BYD"
        },
        {
            "name": "Barry Island",
            "value": "BYI"
        },
        {
            "name": "Barry Links",
            "value": "BYL"
        },
        {
            "name": "Barton-on-Humber",
            "value": "BAU"
        },
        {
            "name": "Basildon",
            "value": "BSO"
        },
        {
            "name": "Basingstoke",
            "value": "BSK"
        },
        {
            "name": "Bat & Ball",
            "value": "BBL"
        },
        {
            "name": "Bath Spa",
            "value": "BTH"
        },
        {
            "name": "Bathgate",
            "value": "BHG"
        },
        {
            "name": "Batley",
            "value": "BTL"
        },
        {
            "name": "Battersby",
            "value": "BTT"
        },
        {
            "name": "Battersea Park",
            "value": "BAK"
        },
        {
            "name": "Battle",
            "value": "BAT"
        },
        {
            "name": "Battlesbridge",
            "value": "BLB"
        },
        {
            "name": "Bayford",
            "value": "BAY"
        },
        {
            "name": "Beaconsfield",
            "value": "BCF"
        },
        {
            "name": "Bearley",
            "value": "BER"
        },
        {
            "name": "Bearsden",
            "value": "BRN"
        },
        {
            "name": "Bearsted",
            "value": "BSD"
        },
        {
            "name": "Beasdale",
            "value": "BSL"
        },
        {
            "name": "Beaulieu Road",
            "value": "BEU"
        },
        {
            "name": "Beauly",
            "value": "BEL"
        },
        {
            "name": "Bebington",
            "value": "BEB"
        },
        {
            "name": "Beccles",
            "value": "BCC"
        },
        {
            "name": "Beckenham Hill",
            "value": "BEC"
        },
        {
            "name": "Beckenham Junction",
            "value": "BKJ"
        },
        {
            "name": "Bedford",
            "value": "BDM"
        },
        {
            "name": "Bedford St Johns",
            "value": "BSJ"
        },
        {
            "name": "Bedhampton",
            "value": "BDH"
        },
        {
            "name": "Bedminster",
            "value": "BMT"
        },
        {
            "name": "Bedworth",
            "value": "BEH"
        },
        {
            "name": "Bedwyn",
            "value": "BDW"
        },
        {
            "name": "Beeston",
            "value": "BEE"
        },
        {
            "name": "Bekesbourne",
            "value": "BKS"
        },
        {
            "name": "Belle Vue",
            "value": "BLV"
        },
        {
            "name": "Bellgrove",
            "value": "BLG"
        },
        {
            "name": "Bellingham",
            "value": "BGM"
        },
        {
            "name": "Bellshill",
            "value": "BLH"
        },
        {
            "name": "Belmont",
            "value": "BLM"
        },
        {
            "name": "Belper",
            "value": "BLP"
        },
        {
            "name": "Beltring",
            "value": "BEG"
        },
        {
            "name": "Belvedere",
            "value": "BVD"
        },
        {
            "name": "Bempton",
            "value": "BEM"
        },
        {
            "name": "Ben Rhydding",
            "value": "BEY"
        },
        {
            "name": "Benfleet",
            "value": "BEF"
        },
        {
            "name": "Bentham",
            "value": "BEN"
        },
        {
            "name": "Bentley (Hants)",
            "value": "BTY"
        },
        {
            "name": "Bentley (South Yorks)",
            "value": "BYK"
        },
        {
            "name": "Bere Alston",
            "value": "BAS"
        },
        {
            "name": "Bere Ferrers",
            "value": "BFE"
        },
        {
            "name": "Berkhamsted",
            "value": "BKM"
        },
        {
            "name": "Berkswell",
            "value": "BKW"
        },
        {
            "name": "Bermuda Park",
            "value": "BEP"
        },
        {
            "name": "Berney Arms",
            "value": "BYA"
        },
        {
            "name": "Berry Brow",
            "value": "BBW"
        },
        {
            "name": "Berrylands",
            "value": "BRS"
        },
        {
            "name": "Berwick (Sussex)",
            "value": "BRK"
        },
        {
            "name": "Berwick-upon-Tweed",
            "value": "BWK"
        },
        {
            "name": "Bescar Lane",
            "value": "BES"
        },
        {
            "name": "Bescot Stadium",
            "value": "BSC"
        },
        {
            "name": "Betchworth",
            "value": "BTO"
        },
        {
            "name": "Bethnal Green",
            "value": "BET"
        },
        {
            "name": "Betws-y-Coed",
            "value": "BYC"
        },
        {
            "name": "Beverley",
            "value": "BEV"
        },
        {
            "name": "Bexhill",
            "value": "BEX"
        },
        {
            "name": "Bexley",
            "value": "BXY"
        },
        {
            "name": "Bexleyheath",
            "value": "BXH"
        },
        {
            "name": "Bicester North",
            "value": "BCS"
        },
        {
            "name": "Bicester Village",
            "value": "BIT"
        },
        {
            "name": "Bickley",
            "value": "BKL"
        },
        {
            "name": "Bidston",
            "value": "BID"
        },
        {
            "name": "Biggleswade",
            "value": "BIW"
        },
        {
            "name": "Bilbrook",
            "value": "BBK"
        },
        {
            "name": "Billericay",
            "value": "BIC"
        },
        {
            "name": "Billingham (Cleveland)",
            "value": "BIL"
        },
        {
            "name": "Billingshurst",
            "value": "BIG"
        },
        {
            "name": "Bingham",
            "value": "BIN"
        },
        {
            "name": "Bingley",
            "value": "BIY"
        },
        {
            "name": "Birchgrove",
            "value": "BCG"
        },
        {
            "name": "Birchington-on-sea",
            "value": "BCH"
        },
        {
            "name": "Birchwood",
            "value": "BWD"
        },
        {
            "name": "Birkbeck",
            "value": "BIK"
        },
        {
            "name": "Birkdale",
            "value": "BDL"
        },
        {
            "name": "Birkenhead Central",
            "value": "BKC"
        },
        {
            "name": "Birkenhead Hamilton Square",
            "value": "BKQ"
        },
        {
            "name": "Birkenhead North",
            "value": "BKN"
        },
        {
            "name": "Birkenhead Park",
            "value": "BKP"
        },
        {
            "name": "Birmingham International",
            "value": "BHI"
        },
        {
            "name": "Birmingham Moor Street",
            "value": "BMO"
        },
        {
            "name": "Birmingham New Street",
            "value": "BHM"
        },
        {
            "name": "Birmingham Snow Hill",
            "value": "BSW"
        },
        {
            "name": "Bishop Auckland",
            "value": "BIA"
        },
        {
            "name": "Bishopbriggs",
            "value": "BBG"
        },
        {
            "name": "Bishops Stortford",
            "value": "BIS"
        },
        {
            "name": "Bishopstone (Sussex)",
            "value": "BIP"
        },
        {
            "name": "Bishopton (Strathclyde)",
            "value": "BPT"
        },
        {
            "name": "Bitterne",
            "value": "BTE"
        },
        {
            "name": "Blackburn",
            "value": "BBN"
        },
        {
            "name": "Blackheath",
            "value": "BKH"
        },
        {
            "name": "Blackhorse Road",
            "value": "BHO"
        },
        {
            "name": "Blackpool North",
            "value": "BPN"
        },
        {
            "name": "Blackpool Pleasure Beach",
            "value": "BPB"
        },
        {
            "name": "Blackpool South",
            "value": "BPS"
        },
        {
            "name": "Blackridge",
            "value": "BKR"
        },
        {
            "name": "Blackrod",
            "value": "BLK"
        },
        {
            "name": "Blackwater",
            "value": "BAW"
        },
        {
            "name": "Blaenau Ffestiniog",
            "value": "BFF"
        },
        {
            "name": "Blair Atholl",
            "value": "BLA"
        },
        {
            "name": "Blairhill",
            "value": "BAI"
        },
        {
            "name": "Blake Street",
            "value": "BKT"
        },
        {
            "name": "Blakedown",
            "value": "BKD"
        },
        {
            "name": "Blantyre",
            "value": "BLT"
        },
        {
            "name": "Blaydon",
            "value": "BLO"
        },
        {
            "name": "Bleasby",
            "value": "BSB"
        },
        {
            "name": "Bletchley",
            "value": "BLY"
        },
        {
            "name": "Bloxwich",
            "value": "BLX"
        },
        {
            "name": "Bloxwich North",
            "value": "BWN"
        },
        {
            "name": "Blundellsands & Crosby",
            "value": "BLN"
        },
        {
            "name": "Blythe Bridge",
            "value": "BYB"
        },
        {
            "name": "Bodmin Parkway",
            "value": "BOD"
        },
        {
            "name": "Bodorgan",
            "value": "BOR"
        },
        {
            "name": "Bognor Regis",
            "value": "BOG"
        },
        {
            "name": "Bogston",
            "value": "BGS"
        },
        {
            "name": "Bolton",
            "value": "BON"
        },
        {
            "name": "Bolton-Upon-Dearne",
            "value": "BTD"
        },
        {
            "name": "Bookham",
            "value": "BKA"
        },
        {
            "name": "Bootle (Cumbria)",
            "value": "BOC"
        },
        {
            "name": "Bootle New Strand",
            "value": "BNW"
        },
        {
            "name": "Bootle Oriel Road",
            "value": "BOT"
        },
        {
            "name": "Bordesley",
            "value": "BBS"
        },
        {
            "name": "Borough Green & Wrotham",
            "value": "BRG"
        },
        {
            "name": "Borth",
            "value": "BRH"
        },
        {
            "name": "Bosham",
            "value": "BOH"
        },
        {
            "name": "Boston",
            "value": "BSN"
        },
        {
            "name": "Botley",
            "value": "BOE"
        },
        {
            "name": "Bottesford",
            "value": "BTF"
        },
        {
            "name": "Bourne End",
            "value": "BNE"
        },
        {
            "name": "Bournemouth",
            "value": "BMH"
        },
        {
            "name": "Bournville",
            "value": "BRV"
        },
        {
            "name": "Bow Brickhill",
            "value": "BWB"
        },
        {
            "name": "Bowes Park",
            "value": "BOP"
        },
        {
            "name": "Bowling",
            "value": "BWG"
        },
        {
            "name": "Box Hill & Westhumble",
            "value": "BXW"
        },
        {
            "name": "Bracknell",
            "value": "BCE"
        },
        {
            "name": "Bradford Forster Square",
            "value": "BDQ"
        },
        {
            "name": "Bradford Interchange",
            "value": "BDI"
        },
        {
            "name": "Bradford-on-Avon",
            "value": "BOA"
        },
        {
            "name": "Brading",
            "value": "BDN"
        },
        {
            "name": "Braintree",
            "value": "BTR"
        },
        {
            "name": "Braintree Freeport",
            "value": "BTP"
        },
        {
            "name": "Bramhall",
            "value": "BML"
        },
        {
            "name": "Bramley (Hants)",
            "value": "BMY"
        },
        {
            "name": "Bramley (W Yorks)",
            "value": "BLE"
        },
        {
            "name": "Brampton (Cumbria)",
            "value": "BMP"
        },
        {
            "name": "Brampton (Suffolk)",
            "value": "BRP"
        },
        {
            "name": "Branchton",
            "value": "BCN"
        },
        {
            "name": "Brandon",
            "value": "BND"
        },
        {
            "name": "Branksome",
            "value": "BSM"
        },
        {
            "name": "Braystones (Cumbria)",
            "value": "BYS"
        },
        {
            "name": "Bredbury",
            "value": "BDY"
        },
        {
            "name": "Breich",
            "value": "BRC"
        },
        {
            "name": "Brentford",
            "value": "BFD"
        },
        {
            "name": "Brentwood",
            "value": "BRE"
        },
        {
            "name": "Bricket Wood",
            "value": "BWO"
        },
        {
            "name": "Bridge of Allan",
            "value": "BEA"
        },
        {
            "name": "Bridge of Orchy",
            "value": "BRO"
        },
        {
            "name": "Bridgend",
            "value": "BGN"
        },
        {
            "name": "Bridgeton",
            "value": "BDG"
        },
        {
            "name": "Bridgwater",
            "value": "BWT"
        },
        {
            "name": "Bridlington",
            "value": "BDT"
        },
        {
            "name": "Brierfield",
            "value": "BRF"
        },
        {
            "name": "Brigg",
            "value": "BGG"
        },
        {
            "name": "Brighouse",
            "value": "BGH"
        },
        {
            "name": "Brighton (East Sussex)",
            "value": "BTN"
        },
        {
            "name": "Brimsdown",
            "value": "BMD"
        },
        {
            "name": "Brinnington",
            "value": "BNT"
        },
        {
            "name": "Bristol Parkway",
            "value": "BPW"
        },
        {
            "name": "Bristol Temple Meads",
            "value": "BRI"
        },
        {
            "name": "Brithdir",
            "value": "BHD"
        },
        {
            "name": "Briton Ferry",
            "value": "BNF"
        },
        {
            "name": "Brixton",
            "value": "BRX"
        },
        {
            "name": "Broad Green",
            "value": "BGE"
        },
        {
            "name": "Broadbottom",
            "value": "BDB"
        },
        {
            "name": "Broadstairs",
            "value": "BSR"
        },
        {
            "name": "Brockenhurst",
            "value": "BCU"
        },
        {
            "name": "Brockholes",
            "value": "BHS"
        },
        {
            "name": "Brockley",
            "value": "BCY"
        },
        {
            "name": "Bromborough",
            "value": "BOM"
        },
        {
            "name": "Bromborough Rake",
            "value": "BMR"
        },
        {
            "name": "Bromley Cross (Lancs)",
            "value": "BMC"
        },
        {
            "name": "Bromley North",
            "value": "BMN"
        },
        {
            "name": "Bromley South",
            "value": "BMS"
        },
        {
            "name": "Bromsgrove",
            "value": "BMV"
        },
        {
            "name": "Brondesbury",
            "value": "BSY"
        },
        {
            "name": "Brondesbury Park",
            "value": "BSP"
        },
        {
            "name": "Brookmans Park",
            "value": "BPK"
        },
        {
            "name": "Brookwood",
            "value": "BKO"
        },
        {
            "name": "Broome",
            "value": "BME"
        },
        {
            "name": "Broomfleet",
            "value": "BMF"
        },
        {
            "name": "Brora",
            "value": "BRA"
        },
        {
            "name": "Brough",
            "value": "BUH"
        },
        {
            "name": "Broughty Ferry",
            "value": "BYF"
        },
        {
            "name": "Broxbourne",
            "value": "BXB"
        },
        {
            "name": "Bruce Grove",
            "value": "BCV"
        },
        {
            "name": "Brundall",
            "value": "BDA"
        },
        {
            "name": "Brundall Gardens",
            "value": "BGA"
        },
        {
            "name": "Brunstane",
            "value": "BSU"
        },
        {
            "name": "Brunswick",
            "value": "BRW"
        },
        {
            "name": "Bruton",
            "value": "BRU"
        },
        {
            "name": "Bryn",
            "value": "BYN"
        },
        {
            "name": "Buckenham (Norfolk)",
            "value": "BUC"
        },
        {
            "name": "Buckley",
            "value": "BCK"
        },
        {
            "name": "Bucknell",
            "value": "BUK"
        },
        {
            "name": "Buckshaw Parkway",
            "value": "BSV"
        },
        {
            "name": "Bugle",
            "value": "BGL"
        },
        {
            "name": "Builth Road",
            "value": "BHR"
        },
        {
            "name": "Bulwell",
            "value": "BLW"
        },
        {
            "name": "Bures",
            "value": "BUE"
        },
        {
            "name": "Burgess Hill",
            "value": "BUG"
        },
        {
            "name": "Burley Park",
            "value": "BUY"
        },
        {
            "name": "Burley-in-Wharfedale",
            "value": "BUW"
        },
        {
            "name": "Burnage",
            "value": "BNA"
        },
        {
            "name": "Burneside (Cumbria)",
            "value": "BUD"
        },
        {
            "name": "Burnham (Bucks)",
            "value": "BNM"
        },
        {
            "name": "Burnham-on-Crouch",
            "value": "BUU"
        },
        {
            "name": "Burnley Barracks",
            "value": "BUB"
        },
        {
            "name": "Burnley Central",
            "value": "BNC"
        },
        {
            "name": "Burnley Manchester Road",
            "value": "BYM"
        },
        {
            "name": "Burnside (Strathclyde)",
            "value": "BUI"
        },
        {
            "name": "Burntisland",
            "value": "BTS"
        },
        {
            "name": "Burscough Bridge",
            "value": "BCB"
        },
        {
            "name": "Burscough Junction",
            "value": "BCJ"
        },
        {
            "name": "Bursledon",
            "value": "BUO"
        },
        {
            "name": "Burton Joyce",
            "value": "BUJ"
        },
        {
            "name": "Burton-on-Trent",
            "value": "BUT"
        },
        {
            "name": "Bury St Edmunds",
            "value": "BSE"
        },
        {
            "name": "Busby",
            "value": "BUS"
        },
        {
            "name": "Bush Hill Park",
            "value": "BHK"
        },
        {
            "name": "Bushey",
            "value": "BSH"
        },
        {
            "name": "Butlers Lane",
            "value": "BUL"
        },
        {
            "name": "Buxted",
            "value": "BXD"
        },
        {
            "name": "Buxton",
            "value": "BUX"
        },
        {
            "name": "Byfleet & New Haw",
            "value": "BFN"
        },
        {
            "name": "Bynea",
            "value": "BYE"
        },
        {
            "name": "Cadoxton",
            "value": "CAD"
        },
        {
            "name": "Caergwrle",
            "value": "CGW"
        },
        {
            "name": "Caerphilly",
            "value": "CPH"
        },
        {
            "name": "Caersws",
            "value": "CWS"
        },
        {
            "name": "Caldercruix",
            "value": "CAC"
        },
        {
            "name": "Caldicot",
            "value": "CDT"
        },
        {
            "name": "Caledonian Rd & Barnsbury",
            "value": "CIR"
        },
        {
            "name": "Calstock",
            "value": "CSK"
        },
        {
            "name": "Cam & Dursley",
            "value": "CDU"
        },
        {
            "name": "Camberley",
            "value": "CAM"
        },
        {
            "name": "Camborne",
            "value": "CBN"
        },
        {
            "name": "Cambridge",
            "value": "CBG"
        },
        {
            "name": "Cambridge Heath",
            "value": "CBH"
        },
        {
            "name": "Cambridge North",
            "value": "CMB"
        },
        {
            "name": "Cambuslang",
            "value": "CBL"
        },
        {
            "name": "Camden Road",
            "value": "CMD"
        },
        {
            "name": "Camelon",
            "value": "CMO"
        },
        {
            "name": "Canada Water",
            "value": "ZCW"
        },
        {
            "name": "Canley",
            "value": "CNL"
        },
        {
            "name": "Cannock",
            "value": "CAO"
        },
        {
            "name": "Canonbury",
            "value": "CNN"
        },
        {
            "name": "Canterbury East",
            "value": "CBE"
        },
        {
            "name": "Canterbury West",
            "value": "CBW"
        },
        {
            "name": "Cantley",
            "value": "CNY"
        },
        {
            "name": "Capenhurst",
            "value": "CPU"
        },
        {
            "name": "Carbis Bay",
            "value": "CBB"
        },
        {
            "name": "Cardenden",
            "value": "CDD"
        },
        {
            "name": "Cardiff Bay",
            "value": "CDB"
        },
        {
            "name": "Cardiff Central",
            "value": "CDF"
        },
        {
            "name": "Cardiff Queen Street",
            "value": "CDQ"
        },
        {
            "name": "Cardonald",
            "value": "CDO"
        },
        {
            "name": "Cardross",
            "value": "CDR"
        },
        {
            "name": "Carfin",
            "value": "CRF"
        },
        {
            "name": "Cark & Cartmel",
            "value": "CAK"
        },
        {
            "name": "Carlisle",
            "value": "CAR"
        },
        {
            "name": "Carlton",
            "value": "CTO"
        },
        {
            "name": "Carluke",
            "value": "CLU"
        },
        {
            "name": "Carmarthen",
            "value": "CMN"
        },
        {
            "name": "Carmyle",
            "value": "CML"
        },
        {
            "name": "Carnforth",
            "value": "CNF"
        },
        {
            "name": "Carnoustie",
            "value": "CAN"
        },
        {
            "name": "Carntyne",
            "value": "CAY"
        },
        {
            "name": "Carpenders Park",
            "value": "CPK"
        },
        {
            "name": "Carrbridge",
            "value": "CAG"
        },
        {
            "name": "Carshalton",
            "value": "CSH"
        },
        {
            "name": "Carshalton Beeches",
            "value": "CSB"
        },
        {
            "name": "Carstairs",
            "value": "CRS"
        },
        {
            "name": "Cartsdyke",
            "value": "CDY"
        },
        {
            "name": "Castle Bar Park",
            "value": "CBP"
        },
        {
            "name": "Castle Cary",
            "value": "CLC"
        },
        {
            "name": "Castleford",
            "value": "CFD"
        },
        {
            "name": "Castleton (Manchester)",
            "value": "CAS"
        },
        {
            "name": "Castleton Moor",
            "value": "CSM"
        },
        {
            "name": "Caterham",
            "value": "CAT"
        },
        {
            "name": "Catford",
            "value": "CTF"
        },
        {
            "name": "Catford Bridge",
            "value": "CFB"
        },
        {
            "name": "Cathays",
            "value": "CYS"
        },
        {
            "name": "Cathcart",
            "value": "CCT"
        },
        {
            "name": "Cattal",
            "value": "CTL"
        },
        {
            "name": "Causeland",
            "value": "CAU"
        },
        {
            "name": "Cefn-y-Bedd",
            "value": "CYB"
        },
        {
            "name": "Chadwell Heath",
            "value": "CTH"
        },
        {
            "name": "Chafford Hundred Lakeside",
            "value": "CFH"
        },
        {
            "name": "Chalfont & Latimer",
            "value": "CFO"
        },
        {
            "name": "Chalkwell",
            "value": "CHW"
        },
        {
            "name": "Chandlers Ford",
            "value": "CFR"
        },
        {
            "name": "Chapel-en-le-Frith",
            "value": "CEF"
        },
        {
            "name": "Chapelton (Devon)",
            "value": "CPN"
        },
        {
            "name": "Chapeltown (South Yorks)",
            "value": "CLN"
        },
        {
            "name": "Chappel & Wakes Colne",
            "value": "CWC"
        },
        {
            "name": "Charing (Kent)",
            "value": "CHG"
        },
        {
            "name": "Charing Cross (Glasgow)",
            "value": "CHC"
        },
        {
            "name": "Charlbury",
            "value": "CBY"
        },
        {
            "name": "Charlton",
            "value": "CTN"
        },
        {
            "name": "Chartham",
            "value": "CRT"
        },
        {
            "name": "Chassen Road",
            "value": "CSR"
        },
        {
            "name": "Chatelherault",
            "value": "CTE"
        },
        {
            "name": "Chatham",
            "value": "CTM"
        },
        {
            "name": "Chathill",
            "value": "CHT"
        },
        {
            "name": "Cheadle Hulme",
            "value": "CHU"
        },
        {
            "name": "Cheam",
            "value": "CHE"
        },
        {
            "name": "Cheddington",
            "value": "CED"
        },
        {
            "name": "Chelford (Cheshire)",
            "value": "CEL"
        },
        {
            "name": "Chelmsford",
            "value": "CHM"
        },
        {
            "name": "Chelsfield",
            "value": "CLD"
        },
        {
            "name": "Cheltenham Spa",
            "value": "CNM"
        },
        {
            "name": "Chepstow",
            "value": "CPW"
        },
        {
            "name": "Cherry Tree",
            "value": "CYT"
        },
        {
            "name": "Chertsey",
            "value": "CHY"
        },
        {
            "name": "Cheshunt",
            "value": "CHN"
        },
        {
            "name": "Chessington North",
            "value": "CSN"
        },
        {
            "name": "Chessington South",
            "value": "CSS"
        },
        {
            "name": "Chester",
            "value": "CTR"
        },
        {
            "name": "Chester Road",
            "value": "CRD"
        },
        {
            "name": "Chesterfield",
            "value": "CHD"
        },
        {
            "name": "Chester-le-Street",
            "value": "CLS"
        },
        {
            "name": "Chestfield & Swalecliffe",
            "value": "CSW"
        },
        {
            "name": "Chetnole",
            "value": "CNO"
        },
        {
            "name": "Chichester",
            "value": "CCH"
        },
        {
            "name": "Chilham",
            "value": "CIL"
        },
        {
            "name": "Chilworth",
            "value": "CHL"
        },
        {
            "name": "Chingford",
            "value": "CHI"
        },
        {
            "name": "Chinley",
            "value": "CLY"
        },
        {
            "name": "Chippenham",
            "value": "CPM"
        },
        {
            "name": "Chipstead",
            "value": "CHP"
        },
        {
            "name": "Chirk",
            "value": "CRK"
        },
        {
            "name": "Chislehurst",
            "value": "CIT"
        },
        {
            "name": "Chiswick",
            "value": "CHK"
        },
        {
            "name": "Cholsey",
            "value": "CHO"
        },
        {
            "name": "Chorley",
            "value": "CRL"
        },
        {
            "name": "Chorleywood",
            "value": "CLW"
        },
        {
            "name": "Christchurch",
            "value": "CHR"
        },
        {
            "name": "Christs Hospital",
            "value": "CHH"
        },
        {
            "name": "Church & Oswaldtwistle",
            "value": "CTW"
        },
        {
            "name": "Church Fenton",
            "value": "CHF"
        },
        {
            "name": "Church Stretton",
            "value": "CTT"
        },
        {
            "name": "Cilmeri",
            "value": "CIM"
        },
        {
            "name": "City Thameslink",
            "value": "CTK"
        },
        {
            "name": "Clacton-on-Sea",
            "value": "CLT"
        },
        {
            "name": "Clandon",
            "value": "CLA"
        },
        {
            "name": "Clapham (North Yorkshire)",
            "value": "CPY"
        },
        {
            "name": "Clapham High Street",
            "value": "CLP"
        },
        {
            "name": "Clapham Junction",
            "value": "CLJ"
        },
        {
            "name": "Clapton",
            "value": "CPT"
        },
        {
            "name": "Clarbeston Road",
            "value": "CLR"
        },
        {
            "name": "Clarkston",
            "value": "CKS"
        },
        {
            "name": "Claverdon",
            "value": "CLV"
        },
        {
            "name": "Claygate",
            "value": "CLG"
        },
        {
            "name": "Cleethorpes",
            "value": "CLE"
        },
        {
            "name": "Cleland",
            "value": "CEA"
        },
        {
            "name": "Clifton (Manchester)",
            "value": "CLI"
        },
        {
            "name": "Clifton Down",
            "value": "CFN"
        },
        {
            "name": "Clitheroe",
            "value": "CLH"
        },
        {
            "name": "Clock House",
            "value": "CLK"
        },
        {
            "name": "Clunderwen",
            "value": "CUW"
        },
        {
            "name": "Clydebank",
            "value": "CYK"
        },
        {
            "name": "Coatbridge Central",
            "value": "CBC"
        },
        {
            "name": "Coatbridge Sunnyside",
            "value": "CBS"
        },
        {
            "name": "Coatdyke",
            "value": "COA"
        },
        {
            "name": "Cobham & Stoke d'Abernon",
            "value": "CSD"
        },
        {
            "name": "Codsall",
            "value": "CSL"
        },
        {
            "name": "Cogan",
            "value": "CGN"
        },
        {
            "name": "Colchester",
            "value": "COL"
        },
        {
            "name": "Colchester Town",
            "value": "CET"
        },
        {
            "name": "Coleshill Parkway",
            "value": "CEH"
        },
        {
            "name": "Collingham",
            "value": "CLM"
        },
        {
            "name": "Collington",
            "value": "CLL"
        },
        {
            "name": "Colne",
            "value": "CNE"
        },
        {
            "name": "Colwall",
            "value": "CWL"
        },
        {
            "name": "Colwyn Bay",
            "value": "CWB"
        },
        {
            "name": "Combe (Oxon)",
            "value": "CME"
        },
        {
            "name": "Commondale",
            "value": "COM"
        },
        {
            "name": "Congleton",
            "value": "CNG"
        },
        {
            "name": "Conisbrough",
            "value": "CNS"
        },
        {
            "name": "Connel Ferry",
            "value": "CON"
        },
        {
            "name": "Conon Bridge",
            "value": "CBD"
        },
        {
            "name": "Cononley",
            "value": "CEY"
        },
        {
            "name": "Conway Park",
            "value": "CNP"
        },
        {
            "name": "Conwy",
            "value": "CNW"
        },
        {
            "name": "Cooden Beach",
            "value": "COB"
        },
        {
            "name": "Cookham",
            "value": "COO"
        },
        {
            "name": "Cooksbridge",
            "value": "CBR"
        },
        {
            "name": "Coombe Junction Halt",
            "value": "COE"
        },
        {
            "name": "Copplestone",
            "value": "COP"
        },
        {
            "name": "Corbridge",
            "value": "CRB"
        },
        {
            "name": "Corby",
            "value": "COR"
        },
        {
            "name": "Corfe Castle",
            "value": "CFC"
        },
        {
            "name": "Corkerhill",
            "value": "CKH"
        },
        {
            "name": "Corkickle",
            "value": "CKL"
        },
        {
            "name": "Corpach",
            "value": "CPA"
        },
        {
            "name": "Corrour",
            "value": "CRR"
        },
        {
            "name": "Coryton",
            "value": "COY"
        },
        {
            "name": "Coseley",
            "value": "CSY"
        },
        {
            "name": "Cosford",
            "value": "COS"
        },
        {
            "name": "Cosham",
            "value": "CSA"
        },
        {
            "name": "Cottingham",
            "value": "CGM"
        },
        {
            "name": "Cottingley",
            "value": "COT"
        },
        {
            "name": "Coulsdon South",
            "value": "CDS"
        },
        {
            "name": "Coulsdon Town",
            "value": "CDN"
        },
        {
            "name": "Coventry",
            "value": "COV"
        },
        {
            "name": "Coventry Arena",
            "value": "CAA"
        },
        {
            "name": "Cowden (Kent)",
            "value": "CWN"
        },
        {
            "name": "Cowdenbeath",
            "value": "COW"
        },
        {
            "name": "Cradley Heath",
            "value": "CRA"
        },
        {
            "name": "Craigendoran",
            "value": "CGD"
        },
        {
            "name": "Cramlington",
            "value": "CRM"
        },
        {
            "name": "Cranbrook (Devon)",
            "value": "CBK"
        },
        {
            "name": "Craven Arms",
            "value": "CRV"
        },
        {
            "name": "Crawley",
            "value": "CRW"
        },
        {
            "name": "Crayford",
            "value": "CRY"
        },
        {
            "name": "Crediton",
            "value": "CDI"
        },
        {
            "name": "Cressing (Essex)",
            "value": "CES"
        },
        {
            "name": "Cressington",
            "value": "CSG"
        },
        {
            "name": "Creswell",
            "value": "CWD"
        },
        {
            "name": "Crewe",
            "value": "CRE"
        },
        {
            "name": "Crewkerne",
            "value": "CKN"
        },
        {
            "name": "Crews Hill",
            "value": "CWH"
        },
        {
            "name": "Crianlarich",
            "value": "CNR"
        },
        {
            "name": "Criccieth",
            "value": "CCC"
        },
        {
            "name": "Cricklewood",
            "value": "CRI"
        },
        {
            "name": "Croftfoot",
            "value": "CFF"
        },
        {
            "name": "Crofton Park",
            "value": "CFT"
        },
        {
            "name": "Cromer",
            "value": "CMR"
        },
        {
            "name": "Cromford",
            "value": "CMF"
        },
        {
            "name": "Crookston",
            "value": "CKT"
        },
        {
            "name": "Cross Gates",
            "value": "CRG"
        },
        {
            "name": "Crossflatts",
            "value": "CFL"
        },
        {
            "name": "Crosshill",
            "value": "COI"
        },
        {
            "name": "Crosskeys",
            "value": "CKY"
        },
        {
            "name": "Crossmyloof",
            "value": "CMY"
        },
        {
            "name": "Croston",
            "value": "CSO"
        },
        {
            "name": "Crouch Hill",
            "value": "CRH"
        },
        {
            "name": "Crowborough",
            "value": "COH"
        },
        {
            "name": "Crowhurst",
            "value": "CWU"
        },
        {
            "name": "Crowle",
            "value": "CWE"
        },
        {
            "name": "Crowthorne",
            "value": "CRN"
        },
        {
            "name": "Croy",
            "value": "CRO"
        },
        {
            "name": "Crystal Palace",
            "value": "CYP"
        },
        {
            "name": "Cuddington",
            "value": "CUD"
        },
        {
            "name": "Cuffley",
            "value": "CUF"
        },
        {
            "name": "Culham",
            "value": "CUM"
        },
        {
            "name": "Culrain",
            "value": "CUA"
        },
        {
            "name": "Cumbernauld",
            "value": "CUB"
        },
        {
            "name": "Cupar",
            "value": "CUP"
        },
        {
            "name": "Curriehill",
            "value": "CUH"
        },
        {
            "name": "Cuxton",
            "value": "CUX"
        },
        {
            "name": "Cwmbach",
            "value": "CMH"
        },
        {
            "name": "Cwmbran",
            "value": "CWM"
        },
        {
            "name": "Cynghordy",
            "value": "CYN"
        },
        {
            "name": "Dagenham Dock",
            "value": "DDK"
        },
        {
            "name": "Daisy Hill",
            "value": "DSY"
        },
        {
            "name": "Dalgety Bay",
            "value": "DAG"
        },
        {
            "name": "Dalmally",
            "value": "DAL"
        },
        {
            "name": "Dalmarnock",
            "value": "DAK"
        },
        {
            "name": "Dalmeny",
            "value": "DAM"
        },
        {
            "name": "Dalmuir",
            "value": "DMR"
        },
        {
            "name": "Dalreoch",
            "value": "DLR"
        },
        {
            "name": "Dalry",
            "value": "DLY"
        },
        {
            "name": "Dalston (Cumbria)",
            "value": "DLS"
        },
        {
            "name": "Dalston Junction",
            "value": "DLJ"
        },
        {
            "name": "Dalston Kingsland",
            "value": "DLK"
        },
        {
            "name": "Dalton (Cumbria)",
            "value": "DLT"
        },
        {
            "name": "Dalwhinnie",
            "value": "DLW"
        },
        {
            "name": "Danby",
            "value": "DNY"
        },
        {
            "name": "Danescourt",
            "value": "DCT"
        },
        {
            "name": "Danzey",
            "value": "DZY"
        },
        {
            "name": "Darlington",
            "value": "DAR"
        },
        {
            "name": "Darnall",
            "value": "DAN"
        },
        {
            "name": "Darsham",
            "value": "DSM"
        },
        {
            "name": "Dartford",
            "value": "DFD"
        },
        {
            "name": "Darton",
            "value": "DRT"
        },
        {
            "name": "Darwen",
            "value": "DWN"
        },
        {
            "name": "Datchet",
            "value": "DAT"
        },
        {
            "name": "Davenport",
            "value": "DVN"
        },
        {
            "name": "Dawlish",
            "value": "DWL"
        },
        {
            "name": "Dawlish Warren",
            "value": "DWW"
        },
        {
            "name": "Deal",
            "value": "DEA"
        },
        {
            "name": "Dean (Wilts)",
            "value": "DEN"
        },
        {
            "name": "Deansgate",
            "value": "DGT"
        },
        {
            "name": "Deganwy",
            "value": "DGY"
        },
        {
            "name": "Deighton",
            "value": "DHN"
        },
        {
            "name": "Delamere",
            "value": "DLM"
        },
        {
            "name": "Denby Dale",
            "value": "DBD"
        },
        {
            "name": "Denham",
            "value": "DNM"
        },
        {
            "name": "Denham Golf Club",
            "value": "DGC"
        },
        {
            "name": "Denmark Hill",
            "value": "DMK"
        },
        {
            "name": "Dent",
            "value": "DNT"
        },
        {
            "name": "Denton",
            "value": "DTN"
        },
        {
            "name": "Deptford",
            "value": "DEP"
        },
        {
            "name": "Derby",
            "value": "DBY"
        },
        {
            "name": "Derby Road (Ipswich)",
            "value": "DBR"
        },
        {
            "name": "Devonport (Devon)",
            "value": "DPT"
        },
        {
            "name": "Devonport Dockyard",
            "value": "DOC"
        },
        {
            "name": "Dewsbury",
            "value": "DEW"
        },
        {
            "name": "Didcot Parkway",
            "value": "DID"
        },
        {
            "name": "Digby & Sowton",
            "value": "DIG"
        },
        {
            "name": "Dilton Marsh",
            "value": "DMH"
        },
        {
            "name": "Dinas (Rhondda)",
            "value": "DMG"
        },
        {
            "name": "Dinas Powys",
            "value": "DNS"
        },
        {
            "name": "Dingle Road",
            "value": "DGL"
        },
        {
            "name": "Dingwall",
            "value": "DIN"
        },
        {
            "name": "Dinsdale",
            "value": "DND"
        },
        {
            "name": "Dinting",
            "value": "DTG"
        },
        {
            "name": "Disley",
            "value": "DSL"
        },
        {
            "name": "Diss",
            "value": "DIS"
        },
        {
            "name": "Dodworth",
            "value": "DOD"
        },
        {
            "name": "Dolau",
            "value": "DOL"
        },
        {
            "name": "Doleham",
            "value": "DLH"
        },
        {
            "name": "Dolgarrog",
            "value": "DLG"
        },
        {
            "name": "Dolwyddelan",
            "value": "DWD"
        },
        {
            "name": "Doncaster",
            "value": "DON"
        },
        {
            "name": "Dorchester South",
            "value": "DCH"
        },
        {
            "name": "Dorchester West",
            "value": "DCW"
        },
        {
            "name": "Dore & Totley",
            "value": "DOR"
        },
        {
            "name": "Dorking (Main)",
            "value": "DKG"
        },
        {
            "name": "Dorking Deepdene",
            "value": "DPD"
        },
        {
            "name": "Dorking West",
            "value": "DKT"
        },
        {
            "name": "Dormans",
            "value": "DMS"
        },
        {
            "name": "Dorridge",
            "value": "DDG"
        },
        {
            "name": "Dove Holes",
            "value": "DVH"
        },
        {
            "name": "Dover Priory",
            "value": "DVP"
        },
        {
            "name": "Dovercourt",
            "value": "DVC"
        },
        {
            "name": "Dovey Junction",
            "value": "DVY"
        },
        {
            "name": "Downham Market",
            "value": "DOW"
        },
        {
            "name": "Drayton Green",
            "value": "DRG"
        },
        {
            "name": "Drayton Park",
            "value": "DYP"
        },
        {
            "name": "Drem",
            "value": "DRM"
        },
        {
            "name": "Driffield",
            "value": "DRF"
        },
        {
            "name": "Drigg",
            "value": "DRI"
        },
        {
            "name": "Droitwich Spa",
            "value": "DTW"
        },
        {
            "name": "Dronfield",
            "value": "DRO"
        },
        {
            "name": "Drumchapel",
            "value": "DMC"
        },
        {
            "name": "Drumfrochar",
            "value": "DFR"
        },
        {
            "name": "Drumgelloch",
            "value": "DRU"
        },
        {
            "name": "Drumry",
            "value": "DMY"
        },
        {
            "name": "Dublin Ferryport",
            "value": "DFP"
        },
        {
            "name": "Dublin Port - Stena",
            "value": "DPS"
        },
        {
            "name": "Duddeston",
            "value": "DUD"
        },
        {
            "name": "Dudley Port",
            "value": "DDP"
        },
        {
            "name": "Duffield",
            "value": "DFI"
        },
        {
            "name": "Duirinish",
            "value": "DRN"
        },
        {
            "name": "Duke Street",
            "value": "DST"
        },
        {
            "name": "Dullingham",
            "value": "DUL"
        },
        {
            "name": "Dumbarton Central",
            "value": "DBC"
        },
        {
            "name": "Dumbarton East",
            "value": "DBE"
        },
        {
            "name": "Dumbreck",
            "value": "DUM"
        },
        {
            "name": "Dumfries",
            "value": "DMF"
        },
        {
            "name": "Dumpton Park",
            "value": "DMP"
        },
        {
            "name": "Dunbar",
            "value": "DUN"
        },
        {
            "name": "Dunblane",
            "value": "DBL"
        },
        {
            "name": "Duncraig",
            "value": "DCG"
        },
        {
            "name": "Dundee",
            "value": "DEE"
        },
        {
            "name": "Dunfermline Queen Margaret",
            "value": "DFL"
        },
        {
            "name": "Dunfermline Town",
            "value": "DFE"
        },
        {
            "name": "Dunkeld & Birnam",
            "value": "DKD"
        },
        {
            "name": "Dunlop",
            "value": "DNL"
        },
        {
            "name": "Dunrobin Castle",
            "value": "DNO"
        },
        {
            "name": "Dunston",
            "value": "DOT"
        },
        {
            "name": "Dunton Green",
            "value": "DNG"
        },
        {
            "name": "Durham",
            "value": "DHM"
        },
        {
            "name": "Durrington-on-Sea",
            "value": "DUR"
        },
        {
            "name": "Dyce",
            "value": "DYC"
        },
        {
            "name": "Dyffryn Ardudwy",
            "value": "DYF"
        },
        {
            "name": "Eaglescliffe",
            "value": "EAG"
        },
        {
            "name": "Ealing Broadway",
            "value": "EAL"
        },
        {
            "name": "Earlestown",
            "value": "ERL"
        },
        {
            "name": "Earley",
            "value": "EAR"
        },
        {
            "name": "Earlsfield",
            "value": "EAD"
        },
        {
            "name": "Earlswood (Surrey)",
            "value": "ELD"
        },
        {
            "name": "Earlswood (West Midlands)",
            "value": "EWD"
        },
        {
            "name": "East Croydon",
            "value": "ECR"
        },
        {
            "name": "East Didsbury",
            "value": "EDY"
        },
        {
            "name": "East Dulwich",
            "value": "EDW"
        },
        {
            "name": "East Farleigh",
            "value": "EFL"
        },
        {
            "name": "East Garforth",
            "value": "EGF"
        },
        {
            "name": "East Grinstead",
            "value": "EGR"
        },
        {
            "name": "East Kilbride",
            "value": "EKL"
        },
        {
            "name": "East Malling",
            "value": "EML"
        },
        {
            "name": "East Midlands Parkway",
            "value": "EMD"
        },
        {
            "name": "East Tilbury",
            "value": "ETL"
        },
        {
            "name": "East Worthing",
            "value": "EWR"
        },
        {
            "name": "Eastbourne",
            "value": "EBN"
        },
        {
            "name": "Eastbrook",
            "value": "EBK"
        },
        {
            "name": "Easterhouse",
            "value": "EST"
        },
        {
            "name": "Eastham Rake",
            "value": "ERA"
        },
        {
            "name": "Eastleigh",
            "value": "ESL"
        },
        {
            "name": "Eastrington",
            "value": "EGN"
        },
        {
            "name": "Ebbsfleet International",
            "value": "EBD"
        },
        {
            "name": "Ebbw Vale Parkway",
            "value": "EBV"
        },
        {
            "name": "Ebbw Vale Town",
            "value": "EBB"
        },
        {
            "name": "Eccles (Manchester)",
            "value": "ECC"
        },
        {
            "name": "Eccles Road",
            "value": "ECS"
        },
        {
            "name": "Eccleston Park",
            "value": "ECL"
        },
        {
            "name": "Edale",
            "value": "EDL"
        },
        {
            "name": "Eden Park",
            "value": "EDN"
        },
        {
            "name": "Edenbridge",
            "value": "EBR"
        },
        {
            "name": "Edenbridge Town",
            "value": "EBT"
        },
        {
            "name": "Edge Hill",
            "value": "EDG"
        },
        {
            "name": "Edinburgh",
            "value": "EDB"
        },
        {
            "name": "Edinburgh Gateway",
            "value": "EGY"
        },
        {
            "name": "Edinburgh Park",
            "value": "EDP"
        },
        {
            "name": "Edmonton Green",
            "value": "EDR"
        },
        {
            "name": "Effingham Junction",
            "value": "EFF"
        },
        {
            "name": "Eggesford",
            "value": "EGG"
        },
        {
            "name": "Egham",
            "value": "EGH"
        },
        {
            "name": "Egton",
            "value": "EGT"
        },
        {
            "name": "Elephant & Castle",
            "value": "EPH"
        },
        {
            "name": "Elephant & Castle (Underground)",
            "value": "ZEL"
        },
        {
            "name": "Elgin",
            "value": "ELG"
        },
        {
            "name": "Ellesmere Port",
            "value": "ELP"
        },
        {
            "name": "Elmers End",
            "value": "ELE"
        },
        {
            "name": "Elmstead Woods",
            "value": "ESD"
        },
        {
            "name": "Elmswell",
            "value": "ESW"
        },
        {
            "name": "Elsecar",
            "value": "ELR"
        },
        {
            "name": "Elsenham (Essex)",
            "value": "ESM"
        },
        {
            "name": "Elstree & Borehamwood",
            "value": "ELS"
        },
        {
            "name": "Eltham",
            "value": "ELW"
        },
        {
            "name": "Elton & Orston",
            "value": "ELO"
        },
        {
            "name": "Ely",
            "value": "ELY"
        },
        {
            "name": "Emerson Park",
            "value": "EMP"
        },
        {
            "name": "Emsworth",
            "value": "EMS"
        },
        {
            "name": "Energlyn & Churchill Park",
            "value": "ECP"
        },
        {
            "name": "Enfield Chase",
            "value": "ENC"
        },
        {
            "name": "Enfield Lock",
            "value": "ENL"
        },
        {
            "name": "Enfield Town",
            "value": "ENF"
        },
        {
            "name": "Entwistle",
            "value": "ENT"
        },
        {
            "name": "Epsom (Surrey)",
            "value": "EPS"
        },
        {
            "name": "Epsom Downs",
            "value": "EPD"
        },
        {
            "name": "Erdington",
            "value": "ERD"
        },
        {
            "name": "Eridge",
            "value": "ERI"
        },
        {
            "name": "Erith",
            "value": "ERH"
        },
        {
            "name": "Esher",
            "value": "ESH"
        },
        {
            "name": "Eskbank",
            "value": "EKB"
        },
        {
            "name": "Essex Road",
            "value": "EXR"
        },
        {
            "name": "Etchingham",
            "value": "ETC"
        },
        {
            "name": "Euxton Balshaw Lane",
            "value": "EBA"
        },
        {
            "name": "Evesham",
            "value": "EVE"
        },
        {
            "name": "Ewell East",
            "value": "EWE"
        },
        {
            "name": "Ewell West",
            "value": "EWW"
        },
        {
            "name": "Exeter Central",
            "value": "EXC"
        },
        {
            "name": "Exeter St David's",
            "value": "EXD"
        },
        {
            "name": "Exeter St Thomas",
            "value": "EXT"
        },
        {
            "name": "Exhibition Centre (Glasgow)",
            "value": "EXG"
        },
        {
            "name": "Exmouth",
            "value": "EXM"
        },
        {
            "name": "Exton",
            "value": "EXN"
        },
        {
            "name": "Eynsford",
            "value": "EYN"
        },
        {
            "name": "Fairbourne",
            "value": "FRB"
        },
        {
            "name": "Fairfield",
            "value": "FRF"
        },
        {
            "name": "Fairlie",
            "value": "FRL"
        },
        {
            "name": "Fairwater",
            "value": "FRW"
        },
        {
            "name": "Falconwood",
            "value": "FCN"
        },
        {
            "name": "Falkirk Grahamston",
            "value": "FKG"
        },
        {
            "name": "Falkirk High",
            "value": "FKK"
        },
        {
            "name": "Falls of Cruachan",
            "value": "FOC"
        },
        {
            "name": "Falmer",
            "value": "FMR"
        },
        {
            "name": "Falmouth Docks",
            "value": "FAL"
        },
        {
            "name": "Falmouth Town",
            "value": "FMT"
        },
        {
            "name": "Fareham",
            "value": "FRM"
        },
        {
            "name": "Farnborough (Main)",
            "value": "FNB"
        },
        {
            "name": "Farnborough North",
            "value": "FNN"
        },
        {
            "name": "Farncombe",
            "value": "FNC"
        },
        {
            "name": "Farnham",
            "value": "FNH"
        },
        {
            "name": "Farningham Road",
            "value": "FNR"
        },
        {
            "name": "Farnworth",
            "value": "FNW"
        },
        {
            "name": "Farringdon",
            "value": "ZFD"
        },
        {
            "name": "Fauldhouse",
            "value": "FLD"
        },
        {
            "name": "Faversham",
            "value": "FAV"
        },
        {
            "name": "Faygate",
            "value": "FGT"
        },
        {
            "name": "Fazakerley",
            "value": "FAZ"
        },
        {
            "name": "Fearn",
            "value": "FRN"
        },
        {
            "name": "Featherstone",
            "value": "FEA"
        },
        {
            "name": "Felixstowe",
            "value": "FLX"
        },
        {
            "name": "Feltham",
            "value": "FEL"
        },
        {
            "name": "Feniton",
            "value": "FNT"
        },
        {
            "name": "Fenny Stratford",
            "value": "FEN"
        },
        {
            "name": "Fernhill",
            "value": "FER"
        },
        {
            "name": "Ferriby",
            "value": "FRY"
        },
        {
            "name": "Ferryside",
            "value": "FYS"
        },
        {
            "name": "Ffairfach",
            "value": "FFA"
        },
        {
            "name": "Filey",
            "value": "FIL"
        },
        {
            "name": "Filton Abbey Wood",
            "value": "FIT"
        },
        {
            "name": "Finchley Road & Frognal",
            "value": "FNY"
        },
        {
            "name": "Finsbury Park",
            "value": "FPK"
        },
        {
            "name": "Finstock",
            "value": "FIN"
        },
        {
            "name": "Fishbourne (Sussex)",
            "value": "FSB"
        },
        {
            "name": "Fishersgate",
            "value": "FSG"
        },
        {
            "name": "Fishguard & Goodwick",
            "value": "FGW"
        },
        {
            "name": "Fishguard Harbour",
            "value": "FGH"
        },
        {
            "name": "Fiskerton",
            "value": "FSK"
        },
        {
            "name": "Fitzwilliam",
            "value": "FZW"
        },
        {
            "name": "Five Ways",
            "value": "FWY"
        },
        {
            "name": "Fleet",
            "value": "FLE"
        },
        {
            "name": "Flimby",
            "value": "FLM"
        },
        {
            "name": "Flint",
            "value": "FLN"
        },
        {
            "name": "Flitwick",
            "value": "FLT"
        },
        {
            "name": "Flixton",
            "value": "FLI"
        },
        {
            "name": "Flowery Field",
            "value": "FLF"
        },
        {
            "name": "Folkestone Central",
            "value": "FKC"
        },
        {
            "name": "Folkestone West",
            "value": "FKW"
        },
        {
            "name": "Ford",
            "value": "FOD"
        },
        {
            "name": "Forest Gate",
            "value": "FOG"
        },
        {
            "name": "Forest Hill",
            "value": "FOH"
        },
        {
            "name": "Formby",
            "value": "FBY"
        },
        {
            "name": "Forres",
            "value": "FOR"
        },
        {
            "name": "Forsinard",
            "value": "FRS"
        },
        {
            "name": "Fort Matilda",
            "value": "FTM"
        },
        {
            "name": "Fort William",
            "value": "FTW"
        },
        {
            "name": "Four Oaks",
            "value": "FOK"
        },
        {
            "name": "Foxfield",
            "value": "FOX"
        },
        {
            "name": "Foxton",
            "value": "FXN"
        },
        {
            "name": "Frant",
            "value": "FRT"
        },
        {
            "name": "Fratton",
            "value": "FTN"
        },
        {
            "name": "Freshfield",
            "value": "FRE"
        },
        {
            "name": "Freshford",
            "value": "FFD"
        },
        {
            "name": "Frimley",
            "value": "FML"
        },
        {
            "name": "Frinton-on-Sea",
            "value": "FRI"
        },
        {
            "name": "Frizinghall",
            "value": "FZH"
        },
        {
            "name": "Frodsham",
            "value": "FRD"
        },
        {
            "name": "Frome",
            "value": "FRO"
        },
        {
            "name": "Fulwell",
            "value": "FLW"
        },
        {
            "name": "Furness Vale",
            "value": "FNV"
        },
        {
            "name": "Furze Platt",
            "value": "FZP"
        },
        {
            "name": "Gainsborough Central",
            "value": "GNB"
        },
        {
            "name": "Gainsborough Lea Road",
            "value": "GBL"
        },
        {
            "name": "Galashiels",
            "value": "GAL"
        },
        {
            "name": "Garelochhead",
            "value": "GCH"
        },
        {
            "name": "Garforth",
            "value": "GRF"
        },
        {
            "name": "Gargrave",
            "value": "GGV"
        },
        {
            "name": "Garrowhill",
            "value": "GAR"
        },
        {
            "name": "Garscadden",
            "value": "GRS"
        },
        {
            "name": "Garsdale",
            "value": "GSD"
        },
        {
            "name": "Garston (Hertfordshire)",
            "value": "GSN"
        },
        {
            "name": "Garswood",
            "value": "GSW"
        },
        {
            "name": "Gartcosh",
            "value": "GRH"
        },
        {
            "name": "Garth (Mid Glamorgan)",
            "value": "GMG"
        },
        {
            "name": "Garth (Powys)",
            "value": "GTH"
        },
        {
            "name": "Garve",
            "value": "GVE"
        },
        {
            "name": "Gathurst",
            "value": "GST"
        },
        {
            "name": "Gatley",
            "value": "GTY"
        },
        {
            "name": "Gatwick Airport",
            "value": "GTW"
        },
        {
            "name": "Georgemas Junction",
            "value": "GGJ"
        },
        {
            "name": "Gerrards Cross",
            "value": "GER"
        },
        {
            "name": "Gidea Park",
            "value": "GDP"
        },
        {
            "name": "Giffnock",
            "value": "GFN"
        },
        {
            "name": "Giggleswick",
            "value": "GIG"
        },
        {
            "name": "Gilberdyke",
            "value": "GBD"
        },
        {
            "name": "Gilfach Fargoed",
            "value": "GFF"
        },
        {
            "name": "Gillingham (Dorset)",
            "value": "GIL"
        },
        {
            "name": "Gillingham (Kent)",
            "value": "GLM"
        },
        {
            "name": "Gilshochill",
            "value": "GSC"
        },
        {
            "name": "Gipsy Hill",
            "value": "GIP"
        },
        {
            "name": "Girvan",
            "value": "GIR"
        },
        {
            "name": "Glaisdale",
            "value": "GLS"
        },
        {
            "name": "Glan Conwy",
            "value": "GCW"
        },
        {
            "name": "Glasgow Central",
            "value": "GLC"
        },
        {
            "name": "Glasgow Queen Street",
            "value": "GLQ"
        },
        {
            "name": "Glasshoughton",
            "value": "GLH"
        },
        {
            "name": "Glazebrook",
            "value": "GLZ"
        },
        {
            "name": "Gleneagles",
            "value": "GLE"
        },
        {
            "name": "Glenfinnan",
            "value": "GLF"
        },
        {
            "name": "Glengarnock",
            "value": "GLG"
        },
        {
            "name": "Glenrothes with Thornton",
            "value": "GLT"
        },
        {
            "name": "Glossop",
            "value": "GLO"
        },
        {
            "name": "Gloucester",
            "value": "GCR"
        },
        {
            "name": "Glynde",
            "value": "GLY"
        },
        {
            "name": "Gobowen",
            "value": "GOB"
        },
        {
            "name": "Godalming",
            "value": "GOD"
        },
        {
            "name": "Godley",
            "value": "GDL"
        },
        {
            "name": "Godstone",
            "value": "GDN"
        },
        {
            "name": "Goldthorpe",
            "value": "GOE"
        },
        {
            "name": "Golf Street",
            "value": "GOF"
        },
        {
            "name": "Golspie",
            "value": "GOL"
        },
        {
            "name": "Gomshall",
            "value": "GOM"
        },
        {
            "name": "Goodmayes",
            "value": "GMY"
        },
        {
            "name": "Goole",
            "value": "GOO"
        },
        {
            "name": "Goostrey",
            "value": "GTR"
        },
        {
            "name": "Gordon Hill",
            "value": "GDH"
        },
        {
            "name": "Gorebridge",
            "value": "GBG"
        },
        {
            "name": "Goring & Streatley",
            "value": "GOR"
        },
        {
            "name": "Goring-by-Sea",
            "value": "GBS"
        },
        {
            "name": "Gorton",
            "value": "GTO"
        },
        {
            "name": "Gospel Oak",
            "value": "GPO"
        },
        {
            "name": "Gourock",
            "value": "GRK"
        },
        {
            "name": "Gowerton",
            "value": "GWN"
        },
        {
            "name": "Goxhill",
            "value": "GOX"
        },
        {
            "name": "Grange Park",
            "value": "GPK"
        },
        {
            "name": "Grange-Over-Sands",
            "value": "GOS"
        },
        {
            "name": "Grangetown (Cardiff)",
            "value": "GTN"
        },
        {
            "name": "Grantham",
            "value": "GRA"
        },
        {
            "name": "Grateley",
            "value": "GRT"
        },
        {
            "name": "Gravelly Hill",
            "value": "GVH"
        },
        {
            "name": "Gravesend",
            "value": "GRV"
        },
        {
            "name": "Grays",
            "value": "GRY"
        },
        {
            "name": "Great Ayton",
            "value": "GTA"
        },
        {
            "name": "Great Bentley",
            "value": "GRB"
        },
        {
            "name": "Great Chesterford",
            "value": "GRC"
        },
        {
            "name": "Great Coates",
            "value": "GCT"
        },
        {
            "name": "Great Malvern",
            "value": "GMV"
        },
        {
            "name": "Great Missenden",
            "value": "GMN"
        },
        {
            "name": "Great Yarmouth",
            "value": "GYM"
        },
        {
            "name": "Green Lane",
            "value": "GNL"
        },
        {
            "name": "Green Road",
            "value": "GNR"
        },
        {
            "name": "Greenbank",
            "value": "GBK"
        },
        {
            "name": "Greenfaulds",
            "value": "GRL"
        },
        {
            "name": "Greenfield",
            "value": "GNF"
        },
        {
            "name": "Greenford",
            "value": "GFD"
        },
        {
            "name": "Greenhithe",
            "value": "GNH"
        },
        {
            "name": "Greenock Central",
            "value": "GKC"
        },
        {
            "name": "Greenock West",
            "value": "GKW"
        },
        {
            "name": "Greenwich",
            "value": "GNW"
        },
        {
            "name": "Gretna Green",
            "value": "GEA"
        },
        {
            "name": "Grimsby Docks",
            "value": "GMD"
        },
        {
            "name": "Grimsby Town",
            "value": "GMB"
        },
        {
            "name": "Grindleford",
            "value": "GRN"
        },
        {
            "name": "Grosmont",
            "value": "GMT"
        },
        {
            "name": "Grove Park",
            "value": "GRP"
        },
        {
            "name": "Guide Bridge",
            "value": "GUI"
        },
        {
            "name": "Guildford",
            "value": "GLD"
        },
        {
            "name": "Guiseley",
            "value": "GSY"
        },
        {
            "name": "Gunnersbury",
            "value": "GUN"
        },
        {
            "name": "Gunnislake",
            "value": "GSL"
        },
        {
            "name": "Gunton",
            "value": "GNT"
        },
        {
            "name": "Gwersyllt",
            "value": "GWE"
        },
        {
            "name": "Gypsy Lane",
            "value": "GYP"
        },
        {
            "name": "Habrough",
            "value": "HAB"
        },
        {
            "name": "Hackbridge",
            "value": "HCB"
        },
        {
            "name": "Hackney Central",
            "value": "HKC"
        },
        {
            "name": "Hackney Downs",
            "value": "HAC"
        },
        {
            "name": "Hackney Wick",
            "value": "HKW"
        },
        {
            "name": "Haddenham & Thame Parkway",
            "value": "HDM"
        },
        {
            "name": "Haddiscoe",
            "value": "HAD"
        },
        {
            "name": "Hadfield",
            "value": "HDF"
        },
        {
            "name": "Hadley Wood",
            "value": "HDW"
        },
        {
            "name": "Hag Fold",
            "value": "HGF"
        },
        {
            "name": "Haggerston",
            "value": "HGG"
        },
        {
            "name": "Hagley",
            "value": "HAG"
        },
        {
            "name": "Hairmyres",
            "value": "HMY"
        },
        {
            "name": "Hale (Manchester)",
            "value": "HAL"
        },
        {
            "name": "Halesworth",
            "value": "HAS"
        },
        {
            "name": "Halewood",
            "value": "HED"
        },
        {
            "name": "Halifax",
            "value": "HFX"
        },
        {
            "name": "Hall Green",
            "value": "HLG"
        },
        {
            "name": "Hall Road",
            "value": "HLR"
        },
        {
            "name": "Halling",
            "value": "HAI"
        },
        {
            "name": "Hall-i'-th'-Wood",
            "value": "HID"
        },
        {
            "name": "Haltwhistle",
            "value": "HWH"
        },
        {
            "name": "Ham Street",
            "value": "HMT"
        },
        {
            "name": "Hamble",
            "value": "HME"
        },
        {
            "name": "Hamilton Central",
            "value": "HNC"
        },
        {
            "name": "Hamilton West",
            "value": "HNW"
        },
        {
            "name": "Hammerton",
            "value": "HMM"
        },
        {
            "name": "Hampden Park (Sussex)",
            "value": "HMD"
        },
        {
            "name": "Hampstead Heath",
            "value": "HDH"
        },
        {
            "name": "Hampton (London)",
            "value": "HMP"
        },
        {
            "name": "Hampton Court",
            "value": "HMC"
        },
        {
            "name": "Hampton Wick",
            "value": "HMW"
        },
        {
            "name": "Hampton-in-Arden",
            "value": "HIA"
        },
        {
            "name": "Hamstead (Birmingham)",
            "value": "HSD"
        },
        {
            "name": "Hamworthy",
            "value": "HAM"
        },
        {
            "name": "Hanborough",
            "value": "HND"
        },
        {
            "name": "Handforth",
            "value": "HTH"
        },
        {
            "name": "Hanwell",
            "value": "HAN"
        },
        {
            "name": "Hapton",
            "value": "HPN"
        },
        {
            "name": "Harlech",
            "value": "HRL"
        },
        {
            "name": "Harlesden",
            "value": "HDN"
        },
        {
            "name": "Harling Road",
            "value": "HRD"
        },
        {
            "name": "Harlington (Beds)",
            "value": "HLN"
        },
        {
            "name": "Harlow Mill",
            "value": "HWM"
        },
        {
            "name": "Harlow Town",
            "value": "HWN"
        },
        {
            "name": "Harold Wood",
            "value": "HRO"
        },
        {
            "name": "Harpenden",
            "value": "HPD"
        },
        {
            "name": "Harrietsham",
            "value": "HRM"
        },
        {
            "name": "Harringay",
            "value": "HGY"
        },
        {
            "name": "Harringay Green Lanes",
            "value": "HRY"
        },
        {
            "name": "Harrington",
            "value": "HRR"
        },
        {
            "name": "Harrogate",
            "value": "HGT"
        },
        {
            "name": "Harrow & Wealdstone",
            "value": "HRW"
        },
        {
            "name": "Harrow-on-the-Hill",
            "value": "HOH"
        },
        {
            "name": "Hartford (Cheshire)",
            "value": "HTF"
        },
        {
            "name": "Hartlebury",
            "value": "HBY"
        },
        {
            "name": "Hartlepool",
            "value": "HPL"
        },
        {
            "name": "Hartwood",
            "value": "HTW"
        },
        {
            "name": "Harwich International",
            "value": "HPQ"
        },
        {
            "name": "Harwich Town",
            "value": "HWC"
        },
        {
            "name": "Haslemere",
            "value": "HSL"
        },
        {
            "name": "Hassocks",
            "value": "HSK"
        },
        {
            "name": "Hastings",
            "value": "HGS"
        },
        {
            "name": "Hatch End",
            "value": "HTE"
        },
        {
            "name": "Hatfield & Stainforth",
            "value": "HFS"
        },
        {
            "name": "Hatfield (Herts)",
            "value": "HAT"
        },
        {
            "name": "Hatfield Peverel",
            "value": "HAP"
        },
        {
            "name": "Hathersage",
            "value": "HSG"
        },
        {
            "name": "Hattersley",
            "value": "HTY"
        },
        {
            "name": "Hatton",
            "value": "HTN"
        },
        {
            "name": "Havant",
            "value": "HAV"
        },
        {
            "name": "Havenhouse",
            "value": "HVN"
        },
        {
            "name": "Haverfordwest",
            "value": "HVF"
        },
        {
            "name": "Hawarden",
            "value": "HWD"
        },
        {
            "name": "Hawarden Bridge",
            "value": "HWB"
        },
        {
            "name": "Hawkhead",
            "value": "HKH"
        },
        {
            "name": "Haydon Bridge",
            "value": "HDB"
        },
        {
            "name": "Haydons Road",
            "value": "HYR"
        },
        {
            "name": "Hayes & Harlington",
            "value": "HAY"
        },
        {
            "name": "Hayes (Kent)",
            "value": "HYS"
        },
        {
            "name": "Hayle",
            "value": "HYL"
        },
        {
            "name": "Haymarket",
            "value": "HYM"
        },
        {
            "name": "Haywards Heath",
            "value": "HHE"
        },
        {
            "name": "Hazel Grove",
            "value": "HAZ"
        },
        {
            "name": "Headcorn",
            "value": "HCN"
        },
        {
            "name": "Headingley",
            "value": "HDY"
        },
        {
            "name": "Headstone Lane",
            "value": "HDL"
        },
        {
            "name": "Heald Green",
            "value": "HDG"
        },
        {
            "name": "Healing",
            "value": "HLI"
        },
        {
            "name": "Heath High Level",
            "value": "HHL"
        },
        {
            "name": "Heath Low Level",
            "value": "HLL"
        },
        {
            "name": "Heathrow Airport Terminal 4",
            "value": "HAF"
        },
        {
            "name": "Heathrow Airport Terminal 5",
            "value": "HWV"
        },
        {
            "name": "Heathrow Airport Terminals 1, 2 and 3",
            "value": "HXX"
        },
        {
            "name": "Heaton Chapel",
            "value": "HTC"
        },
        {
            "name": "Hebden Bridge",
            "value": "HBD"
        },
        {
            "name": "Heckington",
            "value": "HEC"
        },
        {
            "name": "Hedge End",
            "value": "HDE"
        },
        {
            "name": "Hednesford",
            "value": "HNF"
        },
        {
            "name": "Heighington",
            "value": "HEI"
        },
        {
            "name": "Helensburgh Central",
            "value": "HLC"
        },
        {
            "name": "Helensburgh Upper",
            "value": "HLU"
        },
        {
            "name": "Hellifield",
            "value": "HLD"
        },
        {
            "name": "Helmsdale",
            "value": "HMS"
        },
        {
            "name": "Helsby",
            "value": "HSB"
        },
        {
            "name": "Hemel Hempstead",
            "value": "HML"
        },
        {
            "name": "Hendon",
            "value": "HEN"
        },
        {
            "name": "Hengoed",
            "value": "HNG"
        },
        {
            "name": "Henley-in-Arden",
            "value": "HNL"
        },
        {
            "name": "Henley-on-Thames",
            "value": "HOT"
        },
        {
            "name": "Hensall",
            "value": "HEL"
        },
        {
            "name": "Hereford",
            "value": "HFD"
        },
        {
            "name": "Herne Bay",
            "value": "HNB"
        },
        {
            "name": "Herne Hill",
            "value": "HNH"
        },
        {
            "name": "Hersham",
            "value": "HER"
        },
        {
            "name": "Hertford East",
            "value": "HFE"
        },
        {
            "name": "Hertford North",
            "value": "HFN"
        },
        {
            "name": "Hessle",
            "value": "HES"
        },
        {
            "name": "Heswall",
            "value": "HSW"
        },
        {
            "name": "Hever",
            "value": "HEV"
        },
        {
            "name": "Heworth",
            "value": "HEW"
        },
        {
            "name": "Hexham",
            "value": "HEX"
        },
        {
            "name": "Heyford",
            "value": "HYD"
        },
        {
            "name": "Heysham Port",
            "value": "HHB"
        },
        {
            "name": "High Brooms",
            "value": "HIB"
        },
        {
            "name": "High Street (Glasgow)",
            "value": "HST"
        },
        {
            "name": "High Street Kensington Underground",
            "value": "ZHS"
        },
        {
            "name": "High Wycombe",
            "value": "HWY"
        },
        {
            "name": "Higham (Kent)",
            "value": "HGM"
        },
        {
            "name": "Highams Park",
            "value": "HIP"
        },
        {
            "name": "Highbridge & Burnham",
            "value": "HIG"
        },
        {
            "name": "Highbury & Islington",
            "value": "HHY"
        },
        {
            "name": "Hightown",
            "value": "HTO"
        },
        {
            "name": "Hildenborough",
            "value": "HLB"
        },
        {
            "name": "Hillfoot",
            "value": "HLF"
        },
        {
            "name": "Hillington East",
            "value": "HLE"
        },
        {
            "name": "Hillington West",
            "value": "HLW"
        },
        {
            "name": "Hillside",
            "value": "HIL"
        },
        {
            "name": "Hilsea",
            "value": "HLS"
        },
        {
            "name": "Hinchley Wood",
            "value": "HYW"
        },
        {
            "name": "Hinckley (Leics)",
            "value": "HNK"
        },
        {
            "name": "Hindley",
            "value": "HIN"
        },
        {
            "name": "Hinton Admiral",
            "value": "HNA"
        },
        {
            "name": "Hitchin",
            "value": "HIT"
        },
        {
            "name": "Hither Green",
            "value": "HGR"
        },
        {
            "name": "Hockley",
            "value": "HOC"
        },
        {
            "name": "Hollingbourne",
            "value": "HBN"
        },
        {
            "name": "Holmes Chapel",
            "value": "HCH"
        },
        {
            "name": "Holmwood",
            "value": "HLM"
        },
        {
            "name": "Holton Heath",
            "value": "HOL"
        },
        {
            "name": "Holyhead",
            "value": "HHD"
        },
        {
            "name": "Holytown",
            "value": "HLY"
        },
        {
            "name": "Homerton",
            "value": "HMN"
        },
        {
            "name": "Honeybourne",
            "value": "HYB"
        },
        {
            "name": "Honiton",
            "value": "HON"
        },
        {
            "name": "Honley",
            "value": "HOY"
        },
        {
            "name": "Honor Oak Park",
            "value": "HPA"
        },
        {
            "name": "Hook",
            "value": "HOK"
        },
        {
            "name": "Hooton",
            "value": "HOO"
        },
        {
            "name": "Hope (Derbyshire)",
            "value": "HOP"
        },
        {
            "name": "Hope (Flintshire)",
            "value": "HPE"
        },
        {
            "name": "Hopton Heath",
            "value": "HPT"
        },
        {
            "name": "Horden",
            "value": "HRE"
        },
        {
            "name": "Horley",
            "value": "HOR"
        },
        {
            "name": "Hornbeam Park",
            "value": "HBP"
        },
        {
            "name": "Hornsey",
            "value": "HRN"
        },
        {
            "name": "Horsforth",
            "value": "HRS"
        },
        {
            "name": "Horsham",
            "value": "HRH"
        },
        {
            "name": "Horsley",
            "value": "HSY"
        },
        {
            "name": "Horton-in-Ribblesdale",
            "value": "HIR"
        },
        {
            "name": "Horwich Parkway",
            "value": "HWI"
        },
        {
            "name": "Hoscar",
            "value": "HSC"
        },
        {
            "name": "Hough Green",
            "value": "HGN"
        },
        {
            "name": "Hounslow",
            "value": "HOU"
        },
        {
            "name": "Hove",
            "value": "HOV"
        },
        {
            "name": "Hoveton & Wroxham",
            "value": "HXM"
        },
        {
            "name": "How Wood (Herts)",
            "value": "HWW"
        },
        {
            "name": "Howden",
            "value": "HOW"
        },
        {
            "name": "Howwood (Renfrewshire)",
            "value": "HOZ"
        },
        {
            "name": "Hoxton",
            "value": "HOX"
        },
        {
            "name": "Hoylake",
            "value": "HYK"
        },
        {
            "name": "Hubberts Bridge",
            "value": "HBB"
        },
        {
            "name": "Hucknall",
            "value": "HKN"
        },
        {
            "name": "Huddersfield",
            "value": "HUD"
        },
        {
            "name": "Hull",
            "value": "HUL"
        },
        {
            "name": "Humphrey Park",
            "value": "HUP"
        },
        {
            "name": "Huncoat",
            "value": "HCT"
        },
        {
            "name": "Hungerford",
            "value": "HGD"
        },
        {
            "name": "Hunmanby",
            "value": "HUB"
        },
        {
            "name": "Huntingdon",
            "value": "HUN"
        },
        {
            "name": "Huntly",
            "value": "HNT"
        },
        {
            "name": "Hunts Cross",
            "value": "HNX"
        },
        {
            "name": "Hurst Green",
            "value": "HUR"
        },
        {
            "name": "Hutton Cranswick",
            "value": "HUT"
        },
        {
            "name": "Huyton",
            "value": "HUY"
        },
        {
            "name": "Hyde Central",
            "value": "HYC"
        },
        {
            "name": "Hyde North",
            "value": "HYT"
        },
        {
            "name": "Hykeham",
            "value": "HKM"
        },
        {
            "name": "Hyndland",
            "value": "HYN"
        },
        {
            "name": "Hythe (Essex)",
            "value": "HYH"
        },
        {
            "name": "IBM Halt",
            "value": "IBM"
        },
        {
            "name": "Ifield",
            "value": "IFI"
        },
        {
            "name": "Ilford",
            "value": "IFD"
        },
        {
            "name": "Ilkeston",
            "value": "ILN"
        },
        {
            "name": "Ilkley",
            "value": "ILK"
        },
        {
            "name": "Imperial Wharf",
            "value": "IMW"
        },
        {
            "name": "Ince & Elton",
            "value": "INE"
        },
        {
            "name": "Ince (Manchester)",
            "value": "INC"
        },
        {
            "name": "Ingatestone",
            "value": "INT"
        },
        {
            "name": "Insch",
            "value": "INS"
        },
        {
            "name": "Invergordon",
            "value": "IGD"
        },
        {
            "name": "Invergowrie",
            "value": "ING"
        },
        {
            "name": "Inverkeithing",
            "value": "INK"
        },
        {
            "name": "Inverkip",
            "value": "INP"
        },
        {
            "name": "Inverness",
            "value": "INV"
        },
        {
            "name": "Invershin",
            "value": "INH"
        },
        {
            "name": "Inverurie",
            "value": "INR"
        },
        {
            "name": "Ipswich",
            "value": "IPS"
        },
        {
            "name": "Irlam",
            "value": "IRL"
        },
        {
            "name": "Irvine",
            "value": "IRV"
        },
        {
            "name": "Isleworth",
            "value": "ISL"
        },
        {
            "name": "Islip",
            "value": "ISP"
        },
        {
            "name": "Iver",
            "value": "IVR"
        },
        {
            "name": "Ivybridge",
            "value": "IVY"
        },
        {
            "name": "James Cook",
            "value": "JCH"
        },
        {
            "name": "Jewellery Quarter",
            "value": "JEQ"
        },
        {
            "name": "Johnston (Pembs)",
            "value": "JOH"
        },
        {
            "name": "Johnstone (Strathclyde)",
            "value": "JHN"
        },
        {
            "name": "Jordanhill",
            "value": "JOR"
        },
        {
            "name": "Kearsley (Manchester)",
            "value": "KSL"
        },
        {
            "name": "Kearsney (Kent)",
            "value": "KSN"
        },
        {
            "name": "Keighley",
            "value": "KEI"
        },
        {
            "name": "Keith",
            "value": "KEH"
        },
        {
            "name": "Kelvedon",
            "value": "KEL"
        },
        {
            "name": "Kelvindale",
            "value": "KVD"
        },
        {
            "name": "Kemble",
            "value": "KEM"
        },
        {
            "name": "Kempston Hardwick",
            "value": "KMH"
        },
        {
            "name": "Kempton Park Racecourse",
            "value": "KMP"
        },
        {
            "name": "Kemsing",
            "value": "KMS"
        },
        {
            "name": "Kemsley",
            "value": "KML"
        },
        {
            "name": "Kendal",
            "value": "KEN"
        },
        {
            "name": "Kenilworth",
            "value": "KNW"
        },
        {
            "name": "Kenley",
            "value": "KLY"
        },
        {
            "name": "Kennett",
            "value": "KNE"
        },
        {
            "name": "Kennishead",
            "value": "KNS"
        },
        {
            "name": "Kensal Green",
            "value": "KNL"
        },
        {
            "name": "Kensal Rise",
            "value": "KNR"
        },
        {
            "name": "Kensington Olympia",
            "value": "KPA"
        },
        {
            "name": "Kent House",
            "value": "KTH"
        },
        {
            "name": "Kentish Town",
            "value": "KTN"
        },
        {
            "name": "Kentish Town West",
            "value": "KTW"
        },
        {
            "name": "Kenton",
            "value": "KNT"
        },
        {
            "name": "Kents Bank",
            "value": "KBK"
        },
        {
            "name": "Kettering",
            "value": "KET"
        },
        {
            "name": "Kew Bridge",
            "value": "KWB"
        },
        {
            "name": "Kew Gardens",
            "value": "KWG"
        },
        {
            "name": "Keyham",
            "value": "KEY"
        },
        {
            "name": "Keynsham",
            "value": "KYN"
        },
        {
            "name": "Kidbrooke",
            "value": "KDB"
        },
        {
            "name": "Kidderminster",
            "value": "KID"
        },
        {
            "name": "Kidsgrove",
            "value": "KDG"
        },
        {
            "name": "Kidwelly",
            "value": "KWL"
        },
        {
            "name": "Kilburn High Road",
            "value": "KBN"
        },
        {
            "name": "Kildale",
            "value": "KLD"
        },
        {
            "name": "Kildonan",
            "value": "KIL"
        },
        {
            "name": "Kilgetty",
            "value": "KGT"
        },
        {
            "name": "Kilmarnock",
            "value": "KMK"
        },
        {
            "name": "Kilmaurs",
            "value": "KLM"
        },
        {
            "name": "Kilpatrick",
            "value": "KPT"
        },
        {
            "name": "Kilwinning",
            "value": "KWN"
        },
        {
            "name": "Kinbrace",
            "value": "KBC"
        },
        {
            "name": "Kingham",
            "value": "KGM"
        },
        {
            "name": "Kinghorn",
            "value": "KGH"
        },
        {
            "name": "Kings Langley",
            "value": "KGL"
        },
        {
            "name": "Kings Lynn",
            "value": "KLN"
        },
        {
            "name": "Kings Norton",
            "value": "KNN"
        },
        {
            "name": "Kings Nympton",
            "value": "KGN"
        },
        {
            "name": "Kings Park",
            "value": "KGP"
        },
        {
            "name": "Kings Sutton",
            "value": "KGS"
        },
        {
            "name": "Kingsknowe",
            "value": "KGE"
        },
        {
            "name": "Kingston",
            "value": "KNG"
        },
        {
            "name": "Kingswood",
            "value": "KND"
        },
        {
            "name": "Kingussie",
            "value": "KIN"
        },
        {
            "name": "Kintbury",
            "value": "KIT"
        },
        {
            "name": "Kirby Cross",
            "value": "KBX"
        },
        {
            "name": "Kirk Sandall",
            "value": "KKS"
        },
        {
            "name": "Kirkby (Merseyside)",
            "value": "KIR"
        },
        {
            "name": "Kirkby Stephen",
            "value": "KSW"
        },
        {
            "name": "Kirkby-in-Ashfield",
            "value": "KKB"
        },
        {
            "name": "Kirkby-in-Furness",
            "value": "KBF"
        },
        {
            "name": "Kirkcaldy",
            "value": "KDY"
        },
        {
            "name": "Kirkconnel",
            "value": "KRK"
        },
        {
            "name": "Kirkdale",
            "value": "KKD"
        },
        {
            "name": "Kirkham & Wesham",
            "value": "KKM"
        },
        {
            "name": "Kirkhill",
            "value": "KKH"
        },
        {
            "name": "Kirknewton",
            "value": "KKN"
        },
        {
            "name": "Kirkstall Forge",
            "value": "KLF"
        },
        {
            "name": "Kirkwood",
            "value": "KWD"
        },
        {
            "name": "Kirton Lindsey",
            "value": "KTL"
        },
        {
            "name": "Kiveton Bridge",
            "value": "KIV"
        },
        {
            "name": "Kiveton Park",
            "value": "KVP"
        },
        {
            "name": "Knaresborough",
            "value": "KNA"
        },
        {
            "name": "Knebworth",
            "value": "KBW"
        },
        {
            "name": "Knighton",
            "value": "KNI"
        },
        {
            "name": "Knockholt",
            "value": "KCK"
        },
        {
            "name": "Knottingley",
            "value": "KNO"
        },
        {
            "name": "Knucklas",
            "value": "KNU"
        },
        {
            "name": "Knutsford",
            "value": "KNF"
        },
        {
            "name": "Kyle of Lochalsh",
            "value": "KYL"
        },
        {
            "name": "Ladybank",
            "value": "LDY"
        },
        {
            "name": "Ladywell",
            "value": "LAD"
        },
        {
            "name": "Laindon",
            "value": "LAI"
        },
        {
            "name": "Lairg",
            "value": "LRG"
        },
        {
            "name": "Lake",
            "value": "LKE"
        },
        {
            "name": "Lakenheath",
            "value": "LAK"
        },
        {
            "name": "Lamphey",
            "value": "LAM"
        },
        {
            "name": "Lanark",
            "value": "LNK"
        },
        {
            "name": "Lancaster",
            "value": "LAN"
        },
        {
            "name": "Lancing",
            "value": "LAC"
        },
        {
            "name": "Landywood",
            "value": "LAW"
        },
        {
            "name": "Langbank",
            "value": "LGB"
        },
        {
            "name": "Langho",
            "value": "LHO"
        },
        {
            "name": "Langley (Berks)",
            "value": "LNY"
        },
        {
            "name": "Langley Green",
            "value": "LGG"
        },
        {
            "name": "Langley Mill",
            "value": "LGM"
        },
        {
            "name": "Langside",
            "value": "LGS"
        },
        {
            "name": "Langwathby",
            "value": "LGW"
        },
        {
            "name": "Langwith-Whaley Thorns",
            "value": "LAG"
        },
        {
            "name": "Lapford",
            "value": "LAP"
        },
        {
            "name": "Lapworth",
            "value": "LPW"
        },
        {
            "name": "Larbert",
            "value": "LBT"
        },
        {
            "name": "Largs",
            "value": "LAR"
        },
        {
            "name": "Larkhall",
            "value": "LRH"
        },
        {
            "name": "Laurencekirk",
            "value": "LAU"
        },
        {
            "name": "Lawrence Hill",
            "value": "LWH"
        },
        {
            "name": "Layton (Lancs)",
            "value": "LAY"
        },
        {
            "name": "Lazonby & Kirkoswald",
            "value": "LZB"
        },
        {
            "name": "Lea Bridge",
            "value": "LEB"
        },
        {
            "name": "Lea Green",
            "value": "LEG"
        },
        {
            "name": "Lea Hall",
            "value": "LEH"
        },
        {
            "name": "Leagrave",
            "value": "LEA"
        },
        {
            "name": "Lealholm",
            "value": "LHM"
        },
        {
            "name": "Leamington Spa",
            "value": "LMS"
        },
        {
            "name": "Leasowe",
            "value": "LSW"
        },
        {
            "name": "Leatherhead",
            "value": "LHD"
        },
        {
            "name": "Ledbury",
            "value": "LED"
        },
        {
            "name": "Lee (London)",
            "value": "LEE"
        },
        {
            "name": "Leeds",
            "value": "LDS"
        },
        {
            "name": "Leicester",
            "value": "LEI"
        },
        {
            "name": "Leigh (Kent)",
            "value": "LIH"
        },
        {
            "name": "Leigh-on-Sea",
            "value": "LES"
        },
        {
            "name": "Leighton Buzzard",
            "value": "LBZ"
        },
        {
            "name": "Lelant",
            "value": "LEL"
        },
        {
            "name": "Lelant Saltings",
            "value": "LTS"
        },
        {
            "name": "Lenham",
            "value": "LEN"
        },
        {
            "name": "Lenzie",
            "value": "LNZ"
        },
        {
            "name": "Leominster",
            "value": "LEO"
        },
        {
            "name": "Letchworth Garden City",
            "value": "LET"
        },
        {
            "name": "Leuchars (for St. Andrews)",
            "value": "LEU"
        },
        {
            "name": "Levenshulme",
            "value": "LVM"
        },
        {
            "name": "Lewes",
            "value": "LWS"
        },
        {
            "name": "Lewisham",
            "value": "LEW"
        },
        {
            "name": "Leyland",
            "value": "LEY"
        },
        {
            "name": "Leyton Midland Road",
            "value": "LEM"
        },
        {
            "name": "Leytonstone High Road",
            "value": "LER"
        },
        {
            "name": "Lichfield City",
            "value": "LIC"
        },
        {
            "name": "Lichfield Trent Valley",
            "value": "LTV"
        },
        {
            "name": "Lidlington",
            "value": "LID"
        },
        {
            "name": "Limehouse",
            "value": "LHS"
        },
        {
            "name": "Lincoln Central",
            "value": "LCN"
        },
        {
            "name": "Lingfield",
            "value": "LFD"
        },
        {
            "name": "Lingwood",
            "value": "LGD"
        },
        {
            "name": "Linlithgow",
            "value": "LIN"
        },
        {
            "name": "Liphook",
            "value": "LIP"
        },
        {
            "name": "Liskeard",
            "value": "LSK"
        },
        {
            "name": "Liss",
            "value": "LIS"
        },
        {
            "name": "Lisvane & Thornhill",
            "value": "LVT"
        },
        {
            "name": "Little Kimble",
            "value": "LTK"
        },
        {
            "name": "Little Sutton",
            "value": "LTT"
        },
        {
            "name": "Littleborough",
            "value": "LTL"
        },
        {
            "name": "Littlehampton",
            "value": "LIT"
        },
        {
            "name": "Littlehaven",
            "value": "LVN"
        },
        {
            "name": "Littleport",
            "value": "LTP"
        },
        {
            "name": "Liverpool Central",
            "value": "LVC"
        },
        {
            "name": "Liverpool James Street",
            "value": "LVJ"
        },
        {
            "name": "Liverpool Lime Street",
            "value": "LIV"
        },
        {
            "name": "Liverpool South Parkway",
            "value": "LPY"
        },
        {
            "name": "Livingston North",
            "value": "LSN"
        },
        {
            "name": "Livingston South",
            "value": "LVG"
        },
        {
            "name": "Llanaber",
            "value": "LLA"
        },
        {
            "name": "Llanbedr",
            "value": "LBR"
        },
        {
            "name": "Llanbister Road",
            "value": "LLT"
        },
        {
            "name": "Llanbradach",
            "value": "LNB"
        },
        {
            "name": "Llandaf",
            "value": "LLN"
        },
        {
            "name": "Llandanwg",
            "value": "LDN"
        },
        {
            "name": "Llandecwyn",
            "value": "LLC"
        },
        {
            "name": "Llandeilo",
            "value": "LLL"
        },
        {
            "name": "Llandovery",
            "value": "LLV"
        },
        {
            "name": "Llandrindod",
            "value": "LLO"
        },
        {
            "name": "Llandudno",
            "value": "LLD"
        },
        {
            "name": "Llandudno Junction",
            "value": "LLJ"
        },
        {
            "name": "Llandybie",
            "value": "LLI"
        },
        {
            "name": "Llanelli",
            "value": "LLE"
        },
        {
            "name": "Llanfairfechan",
            "value": "LLF"
        },
        {
            "name": "Llanfairpwll",
            "value": "LPG"
        },
        {
            "name": "Llangadog",
            "value": "LLG"
        },
        {
            "name": "Llangammarch",
            "value": "LLM"
        },
        {
            "name": "Llangennech",
            "value": "LLH"
        },
        {
            "name": "Llangynllo",
            "value": "LGO"
        },
        {
            "name": "Llanharan",
            "value": "LLR"
        },
        {
            "name": "Llanhilleth",
            "value": "LTH"
        },
        {
            "name": "Llanishen",
            "value": "LLS"
        },
        {
            "name": "Llanrwst",
            "value": "LWR"
        },
        {
            "name": "Llansamlet",
            "value": "LAS"
        },
        {
            "name": "Llantwit Major",
            "value": "LWM"
        },
        {
            "name": "Llanwrda",
            "value": "LNR"
        },
        {
            "name": "Llanwrtyd",
            "value": "LNW"
        },
        {
            "name": "Llwyngwril",
            "value": "LLW"
        },
        {
            "name": "Llwynypia",
            "value": "LLY"
        },
        {
            "name": "Loch Awe",
            "value": "LHA"
        },
        {
            "name": "Loch Eil Outward Bound",
            "value": "LHE"
        },
        {
            "name": "Lochailort",
            "value": "LCL"
        },
        {
            "name": "Locheilside",
            "value": "LCS"
        },
        {
            "name": "Lochgelly",
            "value": "LCG"
        },
        {
            "name": "Lochluichart",
            "value": "LCC"
        },
        {
            "name": "Lochwinnoch",
            "value": "LHW"
        },
        {
            "name": "Lockerbie",
            "value": "LOC"
        },
        {
            "name": "Lockwood",
            "value": "LCK"
        },
        {
            "name": "London Blackfriars",
            "value": "BFR"
        },
        {
            "name": "London Bridge",
            "value": "LBG"
        },
        {
            "name": "London Cannon Street",
            "value": "CST"
        },
        {
            "name": "London Charing Cross",
            "value": "CHX"
        },
        {
            "name": "London Euston",
            "value": "EUS"
        },
        {
            "name": "London Fenchurch Street",
            "value": "FST"
        },
        {
            "name": "London Fields",
            "value": "LOF"
        },
        {
            "name": "London Kings Cross",
            "value": "KGX"
        },
        {
            "name": "London Liverpool Street",
            "value": "LST"
        },
        {
            "name": "London Marylebone",
            "value": "MYB"
        },
        {
            "name": "London Paddington",
            "value": "PAD"
        },
        {
            "name": "London Road (Brighton)",
            "value": "LRB"
        },
        {
            "name": "London Road (Guildford)",
            "value": "LRD"
        },
        {
            "name": "London St Pancras (Intl)",
            "value": "SPX"
        },
        {
            "name": "London St Pancras International",
            "value": "STP"
        },
        {
            "name": "London Victoria",
            "value": "VIC"
        },
        {
            "name": "London Waterloo",
            "value": "WAT"
        },
        {
            "name": "London Waterloo East",
            "value": "WAE"
        },
        {
            "name": "Long Buckby",
            "value": "LBK"
        },
        {
            "name": "Long Eaton",
            "value": "LGE"
        },
        {
            "name": "Long Preston",
            "value": "LPR"
        },
        {
            "name": "Longbeck",
            "value": "LGK"
        },
        {
            "name": "Longbridge",
            "value": "LOB"
        },
        {
            "name": "Longcross",
            "value": "LNG"
        },
        {
            "name": "Longfield",
            "value": "LGF"
        },
        {
            "name": "Longniddry",
            "value": "LND"
        },
        {
            "name": "Longport",
            "value": "LPT"
        },
        {
            "name": "Longton",
            "value": "LGN"
        },
        {
            "name": "Looe",
            "value": "LOO"
        },
        {
            "name": "Lostock",
            "value": "LOT"
        },
        {
            "name": "Lostock Gralam",
            "value": "LTG"
        },
        {
            "name": "Lostock Hall",
            "value": "LOH"
        },
        {
            "name": "Lostwithiel",
            "value": "LOS"
        },
        {
            "name": "Loughborough",
            "value": "LBO"
        },
        {
            "name": "Loughborough Junction",
            "value": "LGJ"
        },
        {
            "name": "Low Moor",
            "value": "LMR"
        },
        {
            "name": "Lowdham",
            "value": "LOW"
        },
        {
            "name": "Lower Sydenham",
            "value": "LSY"
        },
        {
            "name": "Lowestoft",
            "value": "LWT"
        },
        {
            "name": "Ludlow",
            "value": "LUD"
        },
        {
            "name": "Luton",
            "value": "LUT"
        },
        {
            "name": "Luton Airport Parkway",
            "value": "LTN"
        },
        {
            "name": "Luxulyan",
            "value": "LUX"
        },
        {
            "name": "Lydney",
            "value": "LYD"
        },
        {
            "name": "Lye (West Midlands)",
            "value": "LYE"
        },
        {
            "name": "Lymington Pier",
            "value": "LYP"
        },
        {
            "name": "Lymington Town",
            "value": "LYT"
        },
        {
            "name": "Lympstone Commando",
            "value": "LYC"
        },
        {
            "name": "Lympstone Village",
            "value": "LYM"
        },
        {
            "name": "Lytham",
            "value": "LTM"
        },
        {
            "name": "Macclesfield",
            "value": "MAC"
        },
        {
            "name": "Machynlleth",
            "value": "MCN"
        },
        {
            "name": "Maesteg",
            "value": "MST"
        },
        {
            "name": "Maesteg (Ewenny Road)",
            "value": "MEW"
        },
        {
            "name": "Maghull",
            "value": "MAG"
        },
        {
            "name": "Maghull North",
            "value": "MNS"
        },
        {
            "name": "Maiden Newton",
            "value": "MDN"
        },
        {
            "name": "Maidenhead",
            "value": "MAI"
        },
        {
            "name": "Maidstone Barracks",
            "value": "MDB"
        },
        {
            "name": "Maidstone East",
            "value": "MDE"
        },
        {
            "name": "Maidstone West",
            "value": "MDW"
        },
        {
            "name": "Malden Manor",
            "value": "MAL"
        },
        {
            "name": "Mallaig",
            "value": "MLG"
        },
        {
            "name": "Malton",
            "value": "MLT"
        },
        {
            "name": "Malvern Link",
            "value": "MVL"
        },
        {
            "name": "Manchester Airport",
            "value": "MIA"
        },
        {
            "name": "Manchester Oxford Road",
            "value": "MCO"
        },
        {
            "name": "Manchester Piccadilly",
            "value": "MAN"
        },
        {
            "name": "Manchester United Football Ground",
            "value": "MUF"
        },
        {
            "name": "Manchester Victoria",
            "value": "MCV"
        },
        {
            "name": "Manea",
            "value": "MNE"
        },
        {
            "name": "Manningtree",
            "value": "MNG"
        },
        {
            "name": "Manor Park",
            "value": "MNP"
        },
        {
            "name": "Manor Road",
            "value": "MNR"
        },
        {
            "name": "Manorbier",
            "value": "MRB"
        },
        {
            "name": "Manors",
            "value": "MAS"
        },
        {
            "name": "Mansfield",
            "value": "MFT"
        },
        {
            "name": "Mansfield Woodhouse",
            "value": "MSW"
        },
        {
            "name": "March",
            "value": "MCH"
        },
        {
            "name": "Marden (Kent)",
            "value": "MRN"
        },
        {
            "name": "Margate",
            "value": "MAR"
        },
        {
            "name": "Market Harborough",
            "value": "MHR"
        },
        {
            "name": "Market Rasen",
            "value": "MKR"
        },
        {
            "name": "Markinch",
            "value": "MNC"
        },
        {
            "name": "Marks Tey",
            "value": "MKT"
        },
        {
            "name": "Marlow",
            "value": "MLW"
        },
        {
            "name": "Marple",
            "value": "MPL"
        },
        {
            "name": "Marsden (Yorks)",
            "value": "MSN"
        },
        {
            "name": "Marske",
            "value": "MSK"
        },
        {
            "name": "Marston Green",
            "value": "MGN"
        },
        {
            "name": "Martin Mill",
            "value": "MTM"
        },
        {
            "name": "Martins Heron",
            "value": "MAO"
        },
        {
            "name": "Marton",
            "value": "MTO"
        },
        {
            "name": "Maryhill",
            "value": "MYH"
        },
        {
            "name": "Maryland",
            "value": "MYL"
        },
        {
            "name": "Maryport",
            "value": "MRY"
        },
        {
            "name": "Matlock",
            "value": "MAT"
        },
        {
            "name": "Matlock Bath",
            "value": "MTB"
        },
        {
            "name": "Mauldeth Road",
            "value": "MAU"
        },
        {
            "name": "Maxwell Park",
            "value": "MAX"
        },
        {
            "name": "Maybole",
            "value": "MAY"
        },
        {
            "name": "Maze Hill",
            "value": "MZH"
        },
        {
            "name": "Meadowhall",
            "value": "MHS"
        },
        {
            "name": "Meldreth",
            "value": "MEL"
        },
        {
            "name": "Melksham",
            "value": "MKM"
        },
        {
            "name": "Melton (Suffolk)",
            "value": "MES"
        },
        {
            "name": "Melton Mowbray",
            "value": "MMO"
        },
        {
            "name": "Menheniot",
            "value": "MEN"
        },
        {
            "name": "Menston",
            "value": "MNN"
        },
        {
            "name": "Meols",
            "value": "MEO"
        },
        {
            "name": "Meols Cop",
            "value": "MEC"
        },
        {
            "name": "Meopham",
            "value": "MEP"
        },
        {
            "name": "Meridian Water",
            "value": "MRW"
        },
        {
            "name": "Merryton",
            "value": "MEY"
        },
        {
            "name": "Merstham",
            "value": "MHM"
        },
        {
            "name": "Merthyr Tydfil",
            "value": "MER"
        },
        {
            "name": "Merthyr Vale",
            "value": "MEV"
        },
        {
            "name": "Metheringham",
            "value": "MGM"
        },
        {
            "name": "MetroCentre",
            "value": "MCE"
        },
        {
            "name": "Mexborough",
            "value": "MEX"
        },
        {
            "name": "Micheldever",
            "value": "MIC"
        },
        {
            "name": "Micklefield",
            "value": "MIK"
        },
        {
            "name": "Middlesbrough",
            "value": "MBR"
        },
        {
            "name": "Middlewood",
            "value": "MDL"
        },
        {
            "name": "Midgham",
            "value": "MDG"
        },
        {
            "name": "Milford (Surrey)",
            "value": "MLF"
        },
        {
            "name": "Milford Haven",
            "value": "MFH"
        },
        {
            "name": "Mill Hill (Lancs)",
            "value": "MLH"
        },
        {
            "name": "Mill Hill Broadway",
            "value": "MIL"
        },
        {
            "name": "Millbrook (Beds)",
            "value": "MLB"
        },
        {
            "name": "Millbrook (Hants)",
            "value": "MBK"
        },
        {
            "name": "Milliken Park",
            "value": "MIN"
        },
        {
            "name": "Millom",
            "value": "MLM"
        },
        {
            "name": "Mills Hill (Manchester)",
            "value": "MIH"
        },
        {
            "name": "Milngavie",
            "value": "MLN"
        },
        {
            "name": "Milton Keynes Central",
            "value": "MKC"
        },
        {
            "name": "Minffordd",
            "value": "MFF"
        },
        {
            "name": "Minster",
            "value": "MSR"
        },
        {
            "name": "Mirfield",
            "value": "MIR"
        },
        {
            "name": "Mistley",
            "value": "MIS"
        },
        {
            "name": "Mitcham Eastfields",
            "value": "MTC"
        },
        {
            "name": "Mitcham Junction",
            "value": "MIJ"
        },
        {
            "name": "Mobberley",
            "value": "MOB"
        },
        {
            "name": "Monifieth",
            "value": "MON"
        },
        {
            "name": "Monks Risborough",
            "value": "MRS"
        },
        {
            "name": "Montpelier",
            "value": "MTP"
        },
        {
            "name": "Montrose",
            "value": "MTS"
        },
        {
            "name": "Moorfields",
            "value": "MRF"
        },
        {
            "name": "Moorgate",
            "value": "MOG"
        },
        {
            "name": "Moorside",
            "value": "MSD"
        },
        {
            "name": "Moorthorpe",
            "value": "MRP"
        },
        {
            "name": "Morar",
            "value": "MRR"
        },
        {
            "name": "Morchard Road",
            "value": "MRD"
        },
        {
            "name": "Morden South",
            "value": "MDS"
        },
        {
            "name": "Morecambe",
            "value": "MCM"
        },
        {
            "name": "Moreton (Dorset)",
            "value": "MTN"
        },
        {
            "name": "Moreton (Merseyside)",
            "value": "MRT"
        },
        {
            "name": "Moreton-in-Marsh",
            "value": "MIM"
        },
        {
            "name": "Morfa Mawddach",
            "value": "MFA"
        },
        {
            "name": "Morley",
            "value": "MLY"
        },
        {
            "name": "Morpeth",
            "value": "MPT"
        },
        {
            "name": "Mortimer",
            "value": "MOR"
        },
        {
            "name": "Mortlake",
            "value": "MTL"
        },
        {
            "name": "Moses Gate",
            "value": "MSS"
        },
        {
            "name": "Moss Side",
            "value": "MOS"
        },
        {
            "name": "Mossley (Manchester)",
            "value": "MSL"
        },
        {
            "name": "Mossley Hill",
            "value": "MSH"
        },
        {
            "name": "Mosspark",
            "value": "MPK"
        },
        {
            "name": "Moston",
            "value": "MSO"
        },
        {
            "name": "Motherwell",
            "value": "MTH"
        },
        {
            "name": "Motspur Park",
            "value": "MOT"
        },
        {
            "name": "Mottingham",
            "value": "MTG"
        },
        {
            "name": "Mottisfont & Dunbridge",
            "value": "DBG"
        },
        {
            "name": "Mouldsworth",
            "value": "MLD"
        },
        {
            "name": "Moulsecoomb",
            "value": "MCB"
        },
        {
            "name": "Mount Florida",
            "value": "MFL"
        },
        {
            "name": "Mount Vernon",
            "value": "MTV"
        },
        {
            "name": "Mountain Ash",
            "value": "MTA"
        },
        {
            "name": "Muir of Ord",
            "value": "MOO"
        },
        {
            "name": "Muirend",
            "value": "MUI"
        },
        {
            "name": "Musselburgh",
            "value": "MUB"
        },
        {
            "name": "Mytholmroyd",
            "value": "MYT"
        },
        {
            "name": "Nafferton",
            "value": "NFN"
        },
        {
            "name": "Nailsea & Backwell",
            "value": "NLS"
        },
        {
            "name": "Nairn",
            "value": "NRN"
        },
        {
            "name": "Nantwich",
            "value": "NAN"
        },
        {
            "name": "Narberth",
            "value": "NAR"
        },
        {
            "name": "Narborough",
            "value": "NBR"
        },
        {
            "name": "Navigation Road",
            "value": "NVR"
        },
        {
            "name": "Neath",
            "value": "NTH"
        },
        {
            "name": "Needham Market",
            "value": "NMT"
        },
        {
            "name": "Neilston",
            "value": "NEI"
        },
        {
            "name": "Nelson",
            "value": "NEL"
        },
        {
            "name": "Neston",
            "value": "NES"
        },
        {
            "name": "Netherfield",
            "value": "NET"
        },
        {
            "name": "Nethertown",
            "value": "NRT"
        },
        {
            "name": "Netley",
            "value": "NTL"
        },
        {
            "name": "New Barnet",
            "value": "NBA"
        },
        {
            "name": "New Beckenham",
            "value": "NBC"
        },
        {
            "name": "New Brighton",
            "value": "NBN"
        },
        {
            "name": "New Clee",
            "value": "NCE"
        },
        {
            "name": "New Cross",
            "value": "NWX"
        },
        {
            "name": "New Cross Gate",
            "value": "NXG"
        },
        {
            "name": "New Cumnock",
            "value": "NCK"
        },
        {
            "name": "New Eltham",
            "value": "NEH"
        },
        {
            "name": "New Holland",
            "value": "NHL"
        },
        {
            "name": "New Hythe",
            "value": "NHE"
        },
        {
            "name": "New Lane",
            "value": "NLN"
        },
        {
            "name": "New Malden",
            "value": "NEM"
        },
        {
            "name": "New Mills Central",
            "value": "NMC"
        },
        {
            "name": "New Mills Newtown",
            "value": "NMN"
        },
        {
            "name": "New Milton",
            "value": "NWM"
        },
        {
            "name": "New Pudsey",
            "value": "NPD"
        },
        {
            "name": "New Southgate",
            "value": "NSG"
        },
        {
            "name": "Newark Castle",
            "value": "NCT"
        },
        {
            "name": "Newark North Gate",
            "value": "NNG"
        },
        {
            "name": "Newbridge",
            "value": "NBE"
        },
        {
            "name": "Newbury",
            "value": "NBY"
        },
        {
            "name": "Newbury Racecourse",
            "value": "NRC"
        },
        {
            "name": "Newcastle",
            "value": "NCL"
        },
        {
            "name": "Newcourt",
            "value": "NCO"
        },
        {
            "name": "Newcraighall",
            "value": "NEW"
        },
        {
            "name": "Newhaven Harbour",
            "value": "NVH"
        },
        {
            "name": "Newhaven Town",
            "value": "NVN"
        },
        {
            "name": "Newington",
            "value": "NGT"
        },
        {
            "name": "Newmarket",
            "value": "NMK"
        },
        {
            "name": "Newport (Essex)",
            "value": "NWE"
        },
        {
            "name": "Newport (South Wales)",
            "value": "NWP"
        },
        {
            "name": "Newquay",
            "value": "NQY"
        },
        {
            "name": "Newstead",
            "value": "NSD"
        },
        {
            "name": "Newton (Lanark)",
            "value": "NTN"
        },
        {
            "name": "Newton Abbot",
            "value": "NTA"
        },
        {
            "name": "Newton Aycliffe",
            "value": "NAY"
        },
        {
            "name": "Newton for Hyde",
            "value": "NWN"
        },
        {
            "name": "Newton St Cyres",
            "value": "NTC"
        },
        {
            "name": "Newtongrange",
            "value": "NEG"
        },
        {
            "name": "Newton-le-Willows",
            "value": "NLW"
        },
        {
            "name": "Newtonmore",
            "value": "NWR"
        },
        {
            "name": "Newton-on-Ayr",
            "value": "NOA"
        },
        {
            "name": "Newtown (Powys)",
            "value": "NWT"
        },
        {
            "name": "Ninian Park",
            "value": "NNP"
        },
        {
            "name": "Nitshill",
            "value": "NIT"
        },
        {
            "name": "Norbiton",
            "value": "NBT"
        },
        {
            "name": "Norbury",
            "value": "NRB"
        },
        {
            "name": "Normans Bay",
            "value": "NSB"
        },
        {
            "name": "Normanton",
            "value": "NOR"
        },
        {
            "name": "North Berwick",
            "value": "NBW"
        },
        {
            "name": "North Camp",
            "value": "NCM"
        },
        {
            "name": "North Dulwich",
            "value": "NDL"
        },
        {
            "name": "North Fambridge",
            "value": "NFA"
        },
        {
            "name": "North Llanrwst",
            "value": "NLR"
        },
        {
            "name": "North Queensferry",
            "value": "NQU"
        },
        {
            "name": "North Road (Darlington)",
            "value": "NRD"
        },
        {
            "name": "North Sheen",
            "value": "NSH"
        },
        {
            "name": "North Walsham",
            "value": "NWA"
        },
        {
            "name": "North Wembley",
            "value": "NWB"
        },
        {
            "name": "Northallerton",
            "value": "NTR"
        },
        {
            "name": "Northampton",
            "value": "NMP"
        },
        {
            "name": "Northfield",
            "value": "NFD"
        },
        {
            "name": "Northfleet",
            "value": "NFL"
        },
        {
            "name": "Northolt Park",
            "value": "NLT"
        },
        {
            "name": "Northumberland Park",
            "value": "NUM"
        },
        {
            "name": "Northwich",
            "value": "NWI"
        },
        {
            "name": "Norwich",
            "value": "NRW"
        },
        {
            "name": "Norwood Junction",
            "value": "NWD"
        },
        {
            "name": "Nottingham",
            "value": "NOT"
        },
        {
            "name": "Nuneaton",
            "value": "NUN"
        },
        {
            "name": "Nunhead",
            "value": "NHD"
        },
        {
            "name": "Nunthorpe",
            "value": "NNT"
        },
        {
            "name": "Nutbourne",
            "value": "NUT"
        },
        {
            "name": "Nutfield",
            "value": "NUF"
        },
        {
            "name": "Oakengates",
            "value": "OKN"
        },
        {
            "name": "Oakham",
            "value": "OKM"
        },
        {
            "name": "Oakleigh Park",
            "value": "OKL"
        },
        {
            "name": "Oban",
            "value": "OBN"
        },
        {
            "name": "Ockendon",
            "value": "OCK"
        },
        {
            "name": "Ockley",
            "value": "OLY"
        },
        {
            "name": "Okehampton",
            "value": "OKE"
        },
        {
            "name": "Okehampton",
            "value": "OKE"
        },
        {
            "name": "Old Hill",
            "value": "OHL"
        },
        {
            "name": "Old Roan",
            "value": "ORN"
        },
        {
            "name": "Old Street",
            "value": "OLD"
        },
        {
            "name": "Oldfield Park",
            "value": "OLF"
        },
        {
            "name": "Olton",
            "value": "OLT"
        },
        {
            "name": "Ore",
            "value": "ORE"
        },
        {
            "name": "Ormskirk",
            "value": "OMS"
        },
        {
            "name": "Orpington",
            "value": "ORP"
        },
        {
            "name": "Orrell",
            "value": "ORR"
        },
        {
            "name": "Orrell Park",
            "value": "OPK"
        },
        {
            "name": "Otford",
            "value": "OTF"
        },
        {
            "name": "Oulton Broad North",
            "value": "OUN"
        },
        {
            "name": "Oulton Broad South",
            "value": "OUS"
        },
        {
            "name": "Outwood",
            "value": "OUT"
        },
        {
            "name": "Overpool",
            "value": "OVE"
        },
        {
            "name": "Overton",
            "value": "OVR"
        },
        {
            "name": "Oxenholme Lake District",
            "value": "OXN"
        },
        {
            "name": "Oxford",
            "value": "OXF"
        },
        {
            "name": "Oxford Parkway",
            "value": "OXP"
        },
        {
            "name": "Oxshott",
            "value": "OXS"
        },
        {
            "name": "Oxted",
            "value": "OXT"
        },
        {
            "name": "Paddock Wood",
            "value": "PDW"
        },
        {
            "name": "Padgate",
            "value": "PDG"
        },
        {
            "name": "Paignton",
            "value": "PGN"
        },
        {
            "name": "Paisley Canal",
            "value": "PCN"
        },
        {
            "name": "Paisley Gilmour Street",
            "value": "PYG"
        },
        {
            "name": "Paisley St James",
            "value": "PYJ"
        },
        {
            "name": "Palmers Green",
            "value": "PAL"
        },
        {
            "name": "Pangbourne",
            "value": "PAN"
        },
        {
            "name": "Pannal",
            "value": "PNL"
        },
        {
            "name": "Pantyffynnon",
            "value": "PTF"
        },
        {
            "name": "Par",
            "value": "PAR"
        },
        {
            "name": "Parbold",
            "value": "PBL"
        },
        {
            "name": "Park Street",
            "value": "PKT"
        },
        {
            "name": "Parkstone (Dorset)",
            "value": "PKS"
        },
        {
            "name": "Parson Street",
            "value": "PSN"
        },
        {
            "name": "Partick",
            "value": "PTK"
        },
        {
            "name": "Parton",
            "value": "PRN"
        },
        {
            "name": "Patchway",
            "value": "PWY"
        },
        {
            "name": "Patricroft",
            "value": "PAT"
        },
        {
            "name": "Patterton",
            "value": "PTT"
        },
        {
            "name": "Peartree",
            "value": "PEA"
        },
        {
            "name": "Peckham Rye",
            "value": "PMR"
        },
        {
            "name": "Pegswood",
            "value": "PEG"
        },
        {
            "name": "Pemberton",
            "value": "PEM"
        },
        {
            "name": "Pembrey & Burry Port",
            "value": "PBY"
        },
        {
            "name": "Pembroke",
            "value": "PMB"
        },
        {
            "name": "Pembroke Dock",
            "value": "PMD"
        },
        {
            "name": "Penally",
            "value": "PNA"
        },
        {
            "name": "Penarth",
            "value": "PEN"
        },
        {
            "name": "Pencoed",
            "value": "PCD"
        },
        {
            "name": "Pengam",
            "value": "PGM"
        },
        {
            "name": "Penge East",
            "value": "PNE"
        },
        {
            "name": "Penge West",
            "value": "PNW"
        },
        {
            "name": "Penhelig",
            "value": "PHG"
        },
        {
            "name": "Penistone",
            "value": "PNS"
        },
        {
            "name": "Penkridge",
            "value": "PKG"
        },
        {
            "name": "Penmaenmawr",
            "value": "PMW"
        },
        {
            "name": "Penmere",
            "value": "PNM"
        },
        {
            "name": "Penrhiwceiber",
            "value": "PER"
        },
        {
            "name": "Penrhyndeudraeth",
            "value": "PRH"
        },
        {
            "name": "Penrith (North Lakes)",
            "value": "PNR"
        },
        {
            "name": "Penryn (Cornwall)",
            "value": "PYN"
        },
        {
            "name": "Pensarn (Gwynedd)",
            "value": "PES"
        },
        {
            "name": "Penshurst",
            "value": "PHR"
        },
        {
            "name": "Pentre-Bach",
            "value": "PTB"
        },
        {
            "name": "Pen-y-Bont",
            "value": "PNY"
        },
        {
            "name": "Penychain",
            "value": "PNC"
        },
        {
            "name": "Penyffordd",
            "value": "PNF"
        },
        {
            "name": "Penzance",
            "value": "PNZ"
        },
        {
            "name": "Perranwell",
            "value": "PRW"
        },
        {
            "name": "Perry Barr",
            "value": "PRY"
        },
        {
            "name": "Pershore",
            "value": "PSH"
        },
        {
            "name": "Perth",
            "value": "PTH"
        },
        {
            "name": "Peterborough",
            "value": "PBO"
        },
        {
            "name": "Petersfield",
            "value": "PTR"
        },
        {
            "name": "Petts Wood",
            "value": "PET"
        },
        {
            "name": "Pevensey & Westham",
            "value": "PEV"
        },
        {
            "name": "Pevensey Bay",
            "value": "PEB"
        },
        {
            "name": "Pewsey",
            "value": "PEW"
        },
        {
            "name": "Pilning",
            "value": "PIL"
        },
        {
            "name": "Pinhoe",
            "value": "PIN"
        },
        {
            "name": "Pitlochry",
            "value": "PIT"
        },
        {
            "name": "Pitsea",
            "value": "PSE"
        },
        {
            "name": "Pleasington",
            "value": "PLS"
        },
        {
            "name": "Plockton",
            "value": "PLK"
        },
        {
            "name": "Pluckley",
            "value": "PLC"
        },
        {
            "name": "Plumley",
            "value": "PLM"
        },
        {
            "name": "Plumpton",
            "value": "PMP"
        },
        {
            "name": "Plumstead",
            "value": "PLU"
        },
        {
            "name": "Plymouth",
            "value": "PLY"
        },
        {
            "name": "Pokesdown",
            "value": "POK"
        },
        {
            "name": "Polegate",
            "value": "PLG"
        },
        {
            "name": "Polesworth",
            "value": "PSW"
        },
        {
            "name": "Pollokshaws East",
            "value": "PWE"
        },
        {
            "name": "Pollokshaws West",
            "value": "PWW"
        },
        {
            "name": "Pollokshields East",
            "value": "PLE"
        },
        {
            "name": "Pollokshields West",
            "value": "PLW"
        },
        {
            "name": "Polmont",
            "value": "PMT"
        },
        {
            "name": "Polsloe Bridge",
            "value": "POL"
        },
        {
            "name": "Ponders End",
            "value": "PON"
        },
        {
            "name": "Pontarddulais",
            "value": "PTD"
        },
        {
            "name": "Pontefract Baghill",
            "value": "PFR"
        },
        {
            "name": "Pontefract Monkhill",
            "value": "PFM"
        },
        {
            "name": "Pontefract Tanshelf",
            "value": "POT"
        },
        {
            "name": "Pontlottyn",
            "value": "PLT"
        },
        {
            "name": "Pontyclun",
            "value": "PYC"
        },
        {
            "name": "Pont-y-Pant",
            "value": "PYP"
        },
        {
            "name": "Pontypool & New Inn",
            "value": "PPL"
        },
        {
            "name": "Pontypridd",
            "value": "PPD"
        },
        {
            "name": "Poole",
            "value": "POO"
        },
        {
            "name": "Poppleton",
            "value": "POP"
        },
        {
            "name": "Port Glasgow",
            "value": "PTG"
        },
        {
            "name": "Port Sunlight",
            "value": "PSL"
        },
        {
            "name": "Port Talbot Parkway",
            "value": "PTA"
        },
        {
            "name": "Portchester",
            "value": "PTC"
        },
        {
            "name": "Porth",
            "value": "POR"
        },
        {
            "name": "Porthmadog",
            "value": "PTM"
        },
        {
            "name": "Portlethen",
            "value": "PLN"
        },
        {
            "name": "Portslade",
            "value": "PLD"
        },
        {
            "name": "Portsmouth & Southsea",
            "value": "PMS"
        },
        {
            "name": "Portsmouth Arms",
            "value": "PMA"
        },
        {
            "name": "Portsmouth Harbour",
            "value": "PMH"
        },
        {
            "name": "Possilpark & Parkhouse",
            "value": "PPK"
        },
        {
            "name": "Potters Bar",
            "value": "PBR"
        },
        {
            "name": "Poulton-le-Fylde",
            "value": "PFY"
        },
        {
            "name": "Poynton",
            "value": "PYT"
        },
        {
            "name": "Prees",
            "value": "PRS"
        },
        {
            "name": "Prescot",
            "value": "PSC"
        },
        {
            "name": "Prestatyn",
            "value": "PRT"
        },
        {
            "name": "Prestbury",
            "value": "PRB"
        },
        {
            "name": "Preston (Lancs)",
            "value": "PRE"
        },
        {
            "name": "Preston Park",
            "value": "PRP"
        },
        {
            "name": "Prestonpans",
            "value": "PST"
        },
        {
            "name": "Prestwick International Airport",
            "value": "PRA"
        },
        {
            "name": "Prestwick Town",
            "value": "PTW"
        },
        {
            "name": "Priesthill & Darnley",
            "value": "PTL"
        },
        {
            "name": "Princes Risborough",
            "value": "PRR"
        },
        {
            "name": "Prittlewell",
            "value": "PRL"
        },
        {
            "name": "Prudhoe",
            "value": "PRU"
        },
        {
            "name": "Pulborough",
            "value": "PUL"
        },
        {
            "name": "Purfleet",
            "value": "PFL"
        },
        {
            "name": "Purley",
            "value": "PUR"
        },
        {
            "name": "Purley Oaks",
            "value": "PUO"
        },
        {
            "name": "Putney",
            "value": "PUT"
        },
        {
            "name": "Pwllheli",
            "value": "PWL"
        },
        {
            "name": "Pye Corner",
            "value": "PYE"
        },
        {
            "name": "Pyle",
            "value": "PYL"
        },
        {
            "name": "Quakers Yard",
            "value": "QYD"
        },
        {
            "name": "Queenborough",
            "value": "QBR"
        },
        {
            "name": "Queens Park (Glasgow)",
            "value": "QPK"
        },
        {
            "name": "Queens Park (London)",
            "value": "QPW"
        },
        {
            "name": "Queens Road (Peckham)",
            "value": "QRP"
        },
        {
            "name": "Queenstown Road (Battersea)",
            "value": "QRB"
        },
        {
            "name": "Quintrell Downs",
            "value": "QUI"
        },
        {
            "name": "Radcliffe-on-Trent",
            "value": "RDF"
        },
        {
            "name": "Radlett",
            "value": "RDT"
        },
        {
            "name": "Radley",
            "value": "RAD"
        },
        {
            "name": "Radyr",
            "value": "RDR"
        },
        {
            "name": "Rainford",
            "value": "RNF"
        },
        {
            "name": "Rainham (Essex)",
            "value": "RNM"
        },
        {
            "name": "Rainham (Kent)",
            "value": "RAI"
        },
        {
            "name": "Rainhill",
            "value": "RNH"
        },
        {
            "name": "Ramsgate",
            "value": "RAM"
        },
        {
            "name": "Ramsgreave & Wilpshire",
            "value": "RGW"
        },
        {
            "name": "Rannoch",
            "value": "RAN"
        },
        {
            "name": "Rauceby",
            "value": "RAU"
        },
        {
            "name": "Ravenglass for Eskdale",
            "value": "RAV"
        },
        {
            "name": "Ravensbourne",
            "value": "RVB"
        },
        {
            "name": "Ravensthorpe",
            "value": "RVN"
        },
        {
            "name": "Rawcliffe",
            "value": "RWC"
        },
        {
            "name": "Rayleigh",
            "value": "RLG"
        },
        {
            "name": "Raynes Park",
            "value": "RAY"
        },
        {
            "name": "Reading",
            "value": "RDG"
        },
        {
            "name": "Reading West",
            "value": "RDW"
        },
        {
            "name": "Rectory Road",
            "value": "REC"
        },
        {
            "name": "Redbridge",
            "value": "RDB"
        },
        {
            "name": "Redcar British Steel",
            "value": "RBS"
        },
        {
            "name": "Redcar Central",
            "value": "RCC"
        },
        {
            "name": "Redcar East",
            "value": "RCE"
        },
        {
            "name": "Reddish North",
            "value": "RDN"
        },
        {
            "name": "Reddish South",
            "value": "RDS"
        },
        {
            "name": "Redditch",
            "value": "RDC"
        },
        {
            "name": "Redhill",
            "value": "RDH"
        },
        {
            "name": "Redland",
            "value": "RDA"
        },
        {
            "name": "Redruth",
            "value": "RED"
        },
        {
            "name": "Reedham (Norfolk)",
            "value": "REE"
        },
        {
            "name": "Reedham (Surrey)",
            "value": "RHM"
        },
        {
            "name": "Reigate",
            "value": "REI"
        },
        {
            "name": "Renton",
            "value": "RTN"
        },
        {
            "name": "Retford",
            "value": "RET"
        },
        {
            "name": "Rhiwbina",
            "value": "RHI"
        },
        {
            "name": "Rhoose Cardiff International Airport",
            "value": "RIA"
        },
        {
            "name": "Rhosneigr",
            "value": "RHO"
        },
        {
            "name": "Rhyl",
            "value": "RHL"
        },
        {
            "name": "Rhymney",
            "value": "RHY"
        },
        {
            "name": "Ribblehead",
            "value": "RHD"
        },
        {
            "name": "Rice Lane",
            "value": "RIL"
        },
        {
            "name": "Richmond (London)",
            "value": "RMD"
        },
        {
            "name": "Rickmansworth",
            "value": "RIC"
        },
        {
            "name": "Riddlesdown",
            "value": "RDD"
        },
        {
            "name": "Ridgmont",
            "value": "RID"
        },
        {
            "name": "Riding Mill",
            "value": "RDM"
        },
        {
            "name": "Risca & Pontymister",
            "value": "RCA"
        },
        {
            "name": "Rishton",
            "value": "RIS"
        },
        {
            "name": "Robertsbridge",
            "value": "RBR"
        },
        {
            "name": "Robroyston",
            "value": "RRN"
        },
        {
            "name": "Roby",
            "value": "ROB"
        },
        {
            "name": "Rochdale",
            "value": "RCD"
        },
        {
            "name": "Roche",
            "value": "ROC"
        },
        {
            "name": "Rochester",
            "value": "RTR"
        },
        {
            "name": "Rochford",
            "value": "RFD"
        },
        {
            "name": "Rock Ferry",
            "value": "RFY"
        },
        {
            "name": "Rogart",
            "value": "ROG"
        },
        {
            "name": "Rogerstone",
            "value": "ROR"
        },
        {
            "name": "Rolleston",
            "value": "ROL"
        },
        {
            "name": "Roman Bridge",
            "value": "RMB"
        },
        {
            "name": "Romford",
            "value": "RMF"
        },
        {
            "name": "Romiley",
            "value": "RML"
        },
        {
            "name": "Romsey",
            "value": "ROM"
        },
        {
            "name": "Roose",
            "value": "ROO"
        },
        {
            "name": "Rose Grove",
            "value": "RSG"
        },
        {
            "name": "Rose Hill Marple",
            "value": "RSH"
        },
        {
            "name": "Rosyth",
            "value": "ROS"
        },
        {
            "name": "Rotherham Central",
            "value": "RMC"
        },
        {
            "name": "Rotherhithe",
            "value": "ROE"
        },
        {
            "name": "Roughton Road",
            "value": "RNR"
        },
        {
            "name": "Rowlands Castle",
            "value": "RLN"
        },
        {
            "name": "Rowley Regis",
            "value": "ROW"
        },
        {
            "name": "Roy Bridge",
            "value": "RYB"
        },
        {
            "name": "Roydon",
            "value": "RYN"
        },
        {
            "name": "Royston",
            "value": "RYS"
        },
        {
            "name": "Ruabon",
            "value": "RUA"
        },
        {
            "name": "Rufford",
            "value": "RUF"
        },
        {
            "name": "Rugby",
            "value": "RUG"
        },
        {
            "name": "Rugeley Town",
            "value": "RGT"
        },
        {
            "name": "Rugeley Trent Valley",
            "value": "RGL"
        },
        {
            "name": "Runcorn",
            "value": "RUN"
        },
        {
            "name": "Runcorn East",
            "value": "RUE"
        },
        {
            "name": "Ruskington",
            "value": "RKT"
        },
        {
            "name": "Ruswarp",
            "value": "RUS"
        },
        {
            "name": "Rutherglen",
            "value": "RUT"
        },
        {
            "name": "Ryde Esplanade",
            "value": "RYD"
        },
        {
            "name": "Ryde Pier Head",
            "value": "RYP"
        },
        {
            "name": "Ryde St Johns Road",
            "value": "RYR"
        },
        {
            "name": "Ryder Brow",
            "value": "RRB"
        },
        {
            "name": "Rye (Sussex)",
            "value": "RYE"
        },
        {
            "name": "Rye House",
            "value": "RYH"
        },
        {
            "name": "Salford Central",
            "value": "SFD"
        },
        {
            "name": "Salford Crescent",
            "value": "SLD"
        },
        {
            "name": "Salfords (Surrey)",
            "value": "SAF"
        },
        {
            "name": "Salhouse",
            "value": "SAH"
        },
        {
            "name": "Salisbury",
            "value": "SAL"
        },
        {
            "name": "Saltaire",
            "value": "SAE"
        },
        {
            "name": "Saltash",
            "value": "STS"
        },
        {
            "name": "Saltburn",
            "value": "SLB"
        },
        {
            "name": "Saltcoats",
            "value": "SLT"
        },
        {
            "name": "Saltmarshe",
            "value": "SAM"
        },
        {
            "name": "Salwick",
            "value": "SLW"
        },
        {
            "name": "Sampford Courtenay",
            "value": "SMC"
        },
        {
            "name": "Sandal & Agbrigg",
            "value": "SNA"
        },
        {
            "name": "Sandbach",
            "value": "SDB"
        },
        {
            "name": "Sanderstead",
            "value": "SNR"
        },
        {
            "name": "Sandhills",
            "value": "SDL"
        },
        {
            "name": "Sandhurst (Berks)",
            "value": "SND"
        },
        {
            "name": "Sandling",
            "value": "SDG"
        },
        {
            "name": "Sandown",
            "value": "SAN"
        },
        {
            "name": "Sandplace",
            "value": "SDP"
        },
        {
            "name": "Sandwell & Dudley",
            "value": "SAD"
        },
        {
            "name": "Sandwich",
            "value": "SDW"
        },
        {
            "name": "Sandy",
            "value": "SDY"
        },
        {
            "name": "Sankey for Penketh",
            "value": "SNK"
        },
        {
            "name": "Sanquhar",
            "value": "SQH"
        },
        {
            "name": "Sarn",
            "value": "SRR"
        },
        {
            "name": "Saundersfoot",
            "value": "SDF"
        },
        {
            "name": "Saunderton",
            "value": "SDR"
        },
        {
            "name": "Sawbridgeworth",
            "value": "SAW"
        },
        {
            "name": "Saxilby",
            "value": "SXY"
        },
        {
            "name": "Saxmundham",
            "value": "SAX"
        },
        {
            "name": "Scarborough",
            "value": "SCA"
        },
        {
            "name": "Scotscalder",
            "value": "SCT"
        },
        {
            "name": "Scotstounhill",
            "value": "SCH"
        },
        {
            "name": "Scunthorpe",
            "value": "SCU"
        },
        {
            "name": "Sea Mills",
            "value": "SML"
        },
        {
            "name": "Seaford (Sussex)",
            "value": "SEF"
        },
        {
            "name": "Seaforth & Litherland",
            "value": "SFL"
        },
        {
            "name": "Seaham",
            "value": "SEA"
        },
        {
            "name": "Seamer",
            "value": "SEM"
        },
        {
            "name": "Seascale",
            "value": "SSC"
        },
        {
            "name": "Seaton Carew",
            "value": "SEC"
        },
        {
            "name": "Seer Green & Jordans",
            "value": "SRG"
        },
        {
            "name": "Selby",
            "value": "SBY"
        },
        {
            "name": "Selhurst",
            "value": "SRS"
        },
        {
            "name": "Sellafield",
            "value": "SEL"
        },
        {
            "name": "Selling",
            "value": "SEG"
        },
        {
            "name": "Selly Oak",
            "value": "SLY"
        },
        {
            "name": "Settle",
            "value": "SET"
        },
        {
            "name": "Seven Kings",
            "value": "SVK"
        },
        {
            "name": "Seven Sisters",
            "value": "SVS"
        },
        {
            "name": "Sevenoaks",
            "value": "SEV"
        },
        {
            "name": "Severn Beach",
            "value": "SVB"
        },
        {
            "name": "Severn Tunnel Junction",
            "value": "STJ"
        },
        {
            "name": "Shadwell",
            "value": "SDE"
        },
        {
            "name": "Shalford (Surrey)",
            "value": "SFR"
        },
        {
            "name": "Shanklin",
            "value": "SHN"
        },
        {
            "name": "Shawfair",
            "value": "SFI"
        },
        {
            "name": "Shawford",
            "value": "SHW"
        },
        {
            "name": "Shawlands",
            "value": "SHL"
        },
        {
            "name": "Sheerness-on-Sea",
            "value": "SSS"
        },
        {
            "name": "Sheffield",
            "value": "SHF"
        },
        {
            "name": "Shelford (Cambs)",
            "value": "SED"
        },
        {
            "name": "Shenfield",
            "value": "SNF"
        },
        {
            "name": "Shenstone",
            "value": "SEN"
        },
        {
            "name": "Shepherd's Bush",
            "value": "SPB"
        },
        {
            "name": "Shepherds Well",
            "value": "SPH"
        },
        {
            "name": "Shepley",
            "value": "SPY"
        },
        {
            "name": "Shepperton",
            "value": "SHP"
        },
        {
            "name": "Shepreth",
            "value": "STH"
        },
        {
            "name": "Sherborne",
            "value": "SHE"
        },
        {
            "name": "Sherburn-in-Elmet",
            "value": "SIE"
        },
        {
            "name": "Sheringham",
            "value": "SHM"
        },
        {
            "name": "Shettleston",
            "value": "SLS"
        },
        {
            "name": "Shieldmuir",
            "value": "SDM"
        },
        {
            "name": "Shifnal",
            "value": "SFN"
        },
        {
            "name": "Shildon",
            "value": "SHD"
        },
        {
            "name": "Shiplake",
            "value": "SHI"
        },
        {
            "name": "Shipley (Yorks)",
            "value": "SHY"
        },
        {
            "name": "Shippea Hill",
            "value": "SPP"
        },
        {
            "name": "Shipton",
            "value": "SIP"
        },
        {
            "name": "Shirebrook",
            "value": "SHB"
        },
        {
            "name": "Shirehampton",
            "value": "SHH"
        },
        {
            "name": "Shireoaks",
            "value": "SRO"
        },
        {
            "name": "Shirley",
            "value": "SRL"
        },
        {
            "name": "Shoeburyness",
            "value": "SRY"
        },
        {
            "name": "Sholing",
            "value": "SHO"
        },
        {
            "name": "Shoreditch High Street",
            "value": "SDC"
        },
        {
            "name": "Shoreham (Kent)",
            "value": "SEH"
        },
        {
            "name": "Shoreham-by-Sea",
            "value": "SSE"
        },
        {
            "name": "Shortlands",
            "value": "SRT"
        },
        {
            "name": "Shotton",
            "value": "SHT"
        },
        {
            "name": "Shotts",
            "value": "SHS"
        },
        {
            "name": "Shrewsbury",
            "value": "SHR"
        },
        {
            "name": "Sidcup",
            "value": "SID"
        },
        {
            "name": "Sileby",
            "value": "SIL"
        },
        {
            "name": "Silecroft",
            "value": "SIC"
        },
        {
            "name": "Silkstone Common",
            "value": "SLK"
        },
        {
            "name": "Silver Street",
            "value": "SLV"
        },
        {
            "name": "Silverdale",
            "value": "SVR"
        },
        {
            "name": "Singer",
            "value": "SIN"
        },
        {
            "name": "Sittingbourne",
            "value": "SIT"
        },
        {
            "name": "Skegness",
            "value": "SKG"
        },
        {
            "name": "Skewen",
            "value": "SKE"
        },
        {
            "name": "Skipton",
            "value": "SKI"
        },
        {
            "name": "Slade Green",
            "value": "SGR"
        },
        {
            "name": "Slaithwaite",
            "value": "SWT"
        },
        {
            "name": "Slateford",
            "value": "SLA"
        },
        {
            "name": "Sleaford",
            "value": "SLR"
        },
        {
            "name": "Sleights",
            "value": "SLH"
        },
        {
            "name": "Slough",
            "value": "SLO"
        },
        {
            "name": "Small Heath",
            "value": "SMA"
        },
        {
            "name": "Smallbrook Junction",
            "value": "SAB"
        },
        {
            "name": "Smethwick Galton Bridge",
            "value": "SGB"
        },
        {
            "name": "Smethwick Rolfe Street",
            "value": "SMR"
        },
        {
            "name": "Smithy Bridge",
            "value": "SMB"
        },
        {
            "name": "Snaith",
            "value": "SNI"
        },
        {
            "name": "Snodland",
            "value": "SDA"
        },
        {
            "name": "Snowdown",
            "value": "SWO"
        },
        {
            "name": "Sole Street",
            "value": "SOR"
        },
        {
            "name": "Solihull",
            "value": "SOL"
        },
        {
            "name": "Somerleyton",
            "value": "SYT"
        },
        {
            "name": "South Acton",
            "value": "SAT"
        },
        {
            "name": "South Bank",
            "value": "SBK"
        },
        {
            "name": "South Bermondsey",
            "value": "SBM"
        },
        {
            "name": "South Croydon",
            "value": "SCY"
        },
        {
            "name": "South Elmsall",
            "value": "SES"
        },
        {
            "name": "South Greenford",
            "value": "SGN"
        },
        {
            "name": "South Gyle",
            "value": "SGL"
        },
        {
            "name": "South Hampstead",
            "value": "SOH"
        },
        {
            "name": "South Kenton",
            "value": "SOK"
        },
        {
            "name": "South Merton",
            "value": "SMO"
        },
        {
            "name": "South Milford",
            "value": "SOM"
        },
        {
            "name": "South Ruislip",
            "value": "SRU"
        },
        {
            "name": "South Tottenham",
            "value": "STO"
        },
        {
            "name": "South Wigston",
            "value": "SWS"
        },
        {
            "name": "South Woodham Ferrers",
            "value": "SOF"
        },
        {
            "name": "Southall",
            "value": "STL"
        },
        {
            "name": "Southampton Airport Parkway",
            "value": "SOA"
        },
        {
            "name": "Southampton Central",
            "value": "SOU"
        },
        {
            "name": "Southbourne",
            "value": "SOB"
        },
        {
            "name": "Southbury",
            "value": "SBU"
        },
        {
            "name": "Southease",
            "value": "SEE"
        },
        {
            "name": "Southend Airport",
            "value": "SIA"
        },
        {
            "name": "Southend Central",
            "value": "SOC"
        },
        {
            "name": "Southend East",
            "value": "SOE"
        },
        {
            "name": "Southend Victoria",
            "value": "SOV"
        },
        {
            "name": "Southminster",
            "value": "SMN"
        },
        {
            "name": "Southport",
            "value": "SOP"
        },
        {
            "name": "Southwick",
            "value": "SWK"
        },
        {
            "name": "Sowerby Bridge",
            "value": "SOW"
        },
        {
            "name": "Spalding",
            "value": "SPA"
        },
        {
            "name": "Spean Bridge",
            "value": "SBR"
        },
        {
            "name": "Spital",
            "value": "SPI"
        },
        {
            "name": "Spondon",
            "value": "SPO"
        },
        {
            "name": "Spooner Row",
            "value": "SPN"
        },
        {
            "name": "Spring Road",
            "value": "SRI"
        },
        {
            "name": "Springburn",
            "value": "SPR"
        },
        {
            "name": "Springfield",
            "value": "SPF"
        },
        {
            "name": "Squires Gate",
            "value": "SQU"
        },
        {
            "name": "St Albans Abbey",
            "value": "SAA"
        },
        {
            "name": "St Albans City",
            "value": "SAC"
        },
        {
            "name": "St Andrews Road",
            "value": "SAR"
        },
        {
            "name": "St Annes-on-Sea",
            "value": "SAS"
        },
        {
            "name": "St Austell",
            "value": "SAU"
        },
        {
            "name": "St Bees",
            "value": "SBS"
        },
        {
            "name": "St Budeaux Ferry Road",
            "value": "SBF"
        },
        {
            "name": "St Budeaux Victoria Road",
            "value": "SBV"
        },
        {
            "name": "St Columb Road",
            "value": "SCR"
        },
        {
            "name": "St Denys",
            "value": "SDN"
        },
        {
            "name": "St Erth",
            "value": "SER"
        },
        {
            "name": "St Germans",
            "value": "SGM"
        },
        {
            "name": "St Helens Central",
            "value": "SNH"
        },
        {
            "name": "St Helens Junction",
            "value": "SHJ"
        },
        {
            "name": "St Helier (Surrey)",
            "value": "SIH"
        },
        {
            "name": "St Ives (Cornwall)",
            "value": "SIV"
        },
        {
            "name": "St James Park (Exeter)",
            "value": "SJP"
        },
        {
            "name": "St James Street (Walthamstow)",
            "value": "SJS"
        },
        {
            "name": "St Johns (London)",
            "value": "SAJ"
        },
        {
            "name": "St Keyne Wishing Well Halt",
            "value": "SKN"
        },
        {
            "name": "St Leonards Warrior Square",
            "value": "SLQ"
        },
        {
            "name": "St Margarets (Herts)",
            "value": "SMT"
        },
        {
            "name": "St Margarets (London)",
            "value": "SMG"
        },
        {
            "name": "St Mary Cray",
            "value": "SMY"
        },
        {
            "name": "St Michaels",
            "value": "STM"
        },
        {
            "name": "St Neots",
            "value": "SNO"
        },
        {
            "name": "Stafford",
            "value": "STA"
        },
        {
            "name": "Staines",
            "value": "SNS"
        },
        {
            "name": "Stallingborough",
            "value": "SLL"
        },
        {
            "name": "Stalybridge",
            "value": "SYB"
        },
        {
            "name": "Stamford (Lincs)",
            "value": "SMD"
        },
        {
            "name": "Stamford Hill",
            "value": "SMH"
        },
        {
            "name": "Stanford-le-Hope",
            "value": "SFO"
        },
        {
            "name": "Stanlow & Thornton",
            "value": "SNT"
        },
        {
            "name": "Stansted Airport",
            "value": "SSD"
        },
        {
            "name": "Stansted Mountfitchet",
            "value": "SST"
        },
        {
            "name": "Staplehurst",
            "value": "SPU"
        },
        {
            "name": "Stapleton Road",
            "value": "SRD"
        },
        {
            "name": "Starbeck",
            "value": "SBE"
        },
        {
            "name": "Starcross",
            "value": "SCS"
        },
        {
            "name": "Staveley (Cumbria)",
            "value": "SVL"
        },
        {
            "name": "Stechford",
            "value": "SCF"
        },
        {
            "name": "Steeton & Silsden",
            "value": "SON"
        },
        {
            "name": "Stepps",
            "value": "SPS"
        },
        {
            "name": "Stevenage",
            "value": "SVG"
        },
        {
            "name": "Stevenston",
            "value": "STV"
        },
        {
            "name": "Stewartby",
            "value": "SWR"
        },
        {
            "name": "Stewarton",
            "value": "STT"
        },
        {
            "name": "Stirling",
            "value": "STG"
        },
        {
            "name": "Stockport",
            "value": "SPT"
        },
        {
            "name": "Stocksfield",
            "value": "SKS"
        },
        {
            "name": "Stocksmoor",
            "value": "SSM"
        },
        {
            "name": "Stockton",
            "value": "STK"
        },
        {
            "name": "Stoke Mandeville",
            "value": "SKM"
        },
        {
            "name": "Stoke Newington",
            "value": "SKW"
        },
        {
            "name": "Stoke-on-Trent",
            "value": "SOT"
        },
        {
            "name": "Stone (Staffs)",
            "value": "SNE"
        },
        {
            "name": "Stone Crossing",
            "value": "SCG"
        },
        {
            "name": "Stonebridge Park",
            "value": "SBP"
        },
        {
            "name": "Stonegate",
            "value": "SOG"
        },
        {
            "name": "Stonehaven",
            "value": "STN"
        },
        {
            "name": "Stonehouse",
            "value": "SHU"
        },
        {
            "name": "Stoneleigh",
            "value": "SNL"
        },
        {
            "name": "Stourbridge Junction",
            "value": "SBJ"
        },
        {
            "name": "Stourbridge Town",
            "value": "SBT"
        },
        {
            "name": "Stow",
            "value": "SOI"
        },
        {
            "name": "Stowmarket",
            "value": "SMK"
        },
        {
            "name": "Stranraer",
            "value": "STR"
        },
        {
            "name": "Stratford (London)",
            "value": "SRA"
        },
        {
            "name": "Stratford International",
            "value": "SFA"
        },
        {
            "name": "Stratford-upon-Avon",
            "value": "SAV"
        },
        {
            "name": "Stratford-upon-Avon Parkway",
            "value": "STY"
        },
        {
            "name": "Strathcarron",
            "value": "STC"
        },
        {
            "name": "Strawberry Hill",
            "value": "STW"
        },
        {
            "name": "Streatham (Greater London)",
            "value": "STE"
        },
        {
            "name": "Streatham Common",
            "value": "SRC"
        },
        {
            "name": "Streatham Hill",
            "value": "SRH"
        },
        {
            "name": "Streethouse",
            "value": "SHC"
        },
        {
            "name": "Strines",
            "value": "SRN"
        },
        {
            "name": "Stromeferry",
            "value": "STF"
        },
        {
            "name": "Strood (Kent)",
            "value": "SOO"
        },
        {
            "name": "Stroud (Gloucs)",
            "value": "STD"
        },
        {
            "name": "Sturry",
            "value": "STU"
        },
        {
            "name": "Styal",
            "value": "SYA"
        },
        {
            "name": "Sudbury & Harrow Road",
            "value": "SUD"
        },
        {
            "name": "Sudbury (Suffolk)",
            "value": "SUY"
        },
        {
            "name": "Sudbury Hill Harrow",
            "value": "SDH"
        },
        {
            "name": "Sugar Loaf",
            "value": "SUG"
        },
        {
            "name": "Summerston",
            "value": "SUM"
        },
        {
            "name": "Sunbury",
            "value": "SUU"
        },
        {
            "name": "Sunderland",
            "value": "SUN"
        },
        {
            "name": "Sundridge Park",
            "value": "SUP"
        },
        {
            "name": "Sunningdale",
            "value": "SNG"
        },
        {
            "name": "Sunnymeads",
            "value": "SNY"
        },
        {
            "name": "Surbiton",
            "value": "SUR"
        },
        {
            "name": "Surrey Quays",
            "value": "SQE"
        },
        {
            "name": "Sutton (Surrey)",
            "value": "SUO"
        },
        {
            "name": "Sutton Coldfield",
            "value": "SUT"
        },
        {
            "name": "Sutton Common",
            "value": "SUC"
        },
        {
            "name": "Sutton Parkway",
            "value": "SPK"
        },
        {
            "name": "Swale",
            "value": "SWL"
        },
        {
            "name": "Swanley",
            "value": "SAY"
        },
        {
            "name": "Swanscombe",
            "value": "SWM"
        },
        {
            "name": "Swansea",
            "value": "SWA"
        },
        {
            "name": "Swanwick",
            "value": "SNW"
        },
        {
            "name": "Sway",
            "value": "SWY"
        },
        {
            "name": "Swaythling",
            "value": "SWG"
        },
        {
            "name": "Swinderby",
            "value": "SWD"
        },
        {
            "name": "Swindon (Wilts)",
            "value": "SWI"
        },
        {
            "name": "Swineshead",
            "value": "SWE"
        },
        {
            "name": "Swinton (Manchester)",
            "value": "SNN"
        },
        {
            "name": "Swinton (South Yorks)",
            "value": "SWN"
        },
        {
            "name": "Sydenham (London)",
            "value": "SYD"
        },
        {
            "name": "Sydenham Hill",
            "value": "SYH"
        },
        {
            "name": "Syon Lane",
            "value": "SYL"
        },
        {
            "name": "Syston",
            "value": "SYS"
        },
        {
            "name": "Tackley",
            "value": "TAC"
        },
        {
            "name": "Tadworth",
            "value": "TAD"
        },
        {
            "name": "Taffs Well",
            "value": "TAF"
        },
        {
            "name": "Tain",
            "value": "TAI"
        },
        {
            "name": "Talsarnau",
            "value": "TAL"
        },
        {
            "name": "Talybont",
            "value": "TLB"
        },
        {
            "name": "Tal-y-Cafn",
            "value": "TLC"
        },
        {
            "name": "Tame Bridge Parkway",
            "value": "TAB"
        },
        {
            "name": "Tamworth",
            "value": "TAM"
        },
        {
            "name": "Taplow",
            "value": "TAP"
        },
        {
            "name": "Tattenham Corner",
            "value": "TAT"
        },
        {
            "name": "Taunton",
            "value": "TAU"
        },
        {
            "name": "Taynuilt",
            "value": "TAY"
        },
        {
            "name": "Teddington",
            "value": "TED"
        },
        {
            "name": "Tees-side Airport",
            "value": "TEA"
        },
        {
            "name": "Teignmouth",
            "value": "TGM"
        },
        {
            "name": "Telford Central",
            "value": "TFC"
        },
        {
            "name": "Templecombe",
            "value": "TMC"
        },
        {
            "name": "Tenby",
            "value": "TEN"
        },
        {
            "name": "Teynham",
            "value": "TEY"
        },
        {
            "name": "Thames Ditton",
            "value": "THD"
        },
        {
            "name": "Thatcham",
            "value": "THA"
        },
        {
            "name": "Thatto Heath",
            "value": "THH"
        },
        {
            "name": "The Hawthorns",
            "value": "THW"
        },
        {
            "name": "The Lakes (Warks)",
            "value": "TLK"
        },
        {
            "name": "Theale",
            "value": "THE"
        },
        {
            "name": "Theobalds Grove",
            "value": "TEO"
        },
        {
            "name": "Thetford",
            "value": "TTF"
        },
        {
            "name": "Thirsk",
            "value": "THI"
        },
        {
            "name": "Thornaby",
            "value": "TBY"
        },
        {
            "name": "Thorne North",
            "value": "TNN"
        },
        {
            "name": "Thorne South",
            "value": "TNS"
        },
        {
            "name": "Thornford",
            "value": "THO"
        },
        {
            "name": "Thornliebank",
            "value": "THB"
        },
        {
            "name": "Thornton Abbey",
            "value": "TNA"
        },
        {
            "name": "Thornton Heath",
            "value": "TTH"
        },
        {
            "name": "Thorntonhall",
            "value": "THT"
        },
        {
            "name": "Thorpe Bay",
            "value": "TPB"
        },
        {
            "name": "Thorpe Culvert",
            "value": "TPC"
        },
        {
            "name": "Thorpe-le-Soken",
            "value": "TLS"
        },
        {
            "name": "Three Bridges",
            "value": "TBD"
        },
        {
            "name": "Three Oaks",
            "value": "TOK"
        },
        {
            "name": "Thurgarton",
            "value": "THU"
        },
        {
            "name": "Thurnscoe",
            "value": "THC"
        },
        {
            "name": "Thurso",
            "value": "THS"
        },
        {
            "name": "Thurston",
            "value": "TRS"
        },
        {
            "name": "Tilbury Town",
            "value": "TIL"
        },
        {
            "name": "Tile Hill",
            "value": "THL"
        },
        {
            "name": "Tilehurst",
            "value": "TLH"
        },
        {
            "name": "Tipton",
            "value": "TIP"
        },
        {
            "name": "Tir-Phil",
            "value": "TIR"
        },
        {
            "name": "Tisbury",
            "value": "TIS"
        },
        {
            "name": "Tiverton Parkway",
            "value": "TVP"
        },
        {
            "name": "Todmorden",
            "value": "TOD"
        },
        {
            "name": "Tolworth",
            "value": "TOL"
        },
        {
            "name": "Ton Pentre",
            "value": "TPN"
        },
        {
            "name": "Tonbridge",
            "value": "TON"
        },
        {
            "name": "Tondu",
            "value": "TDU"
        },
        {
            "name": "Tonfanau",
            "value": "TNF"
        },
        {
            "name": "Tonypandy",
            "value": "TNP"
        },
        {
            "name": "Tooting",
            "value": "TOO"
        },
        {
            "name": "Topsham",
            "value": "TOP"
        },
        {
            "name": "Torquay",
            "value": "TQY"
        },
        {
            "name": "Torre",
            "value": "TRR"
        },
        {
            "name": "Totnes",
            "value": "TOT"
        },
        {
            "name": "Tottenham Hale",
            "value": "TOM"
        },
        {
            "name": "Totton",
            "value": "TTN"
        },
        {
            "name": "Town Green",
            "value": "TWN"
        },
        {
            "name": "Trafford Park",
            "value": "TRA"
        },
        {
            "name": "Trefforest",
            "value": "TRF"
        },
        {
            "name": "Trefforest Estate",
            "value": "TRE"
        },
        {
            "name": "Trehafod",
            "value": "TRH"
        },
        {
            "name": "Treherbert",
            "value": "TRB"
        },
        {
            "name": "Treorchy",
            "value": "TRY"
        },
        {
            "name": "Trimley",
            "value": "TRM"
        },
        {
            "name": "Tring",
            "value": "TRI"
        },
        {
            "name": "Troed-y-rhiw",
            "value": "TRD"
        },
        {
            "name": "Troon",
            "value": "TRN"
        },
        {
            "name": "Trowbridge",
            "value": "TRO"
        },
        {
            "name": "Truro",
            "value": "TRU"
        },
        {
            "name": "Tulloch",
            "value": "TUL"
        },
        {
            "name": "Tulse Hill",
            "value": "TUH"
        },
        {
            "name": "Tunbridge Wells",
            "value": "TBW"
        },
        {
            "name": "Turkey Street",
            "value": "TUR"
        },
        {
            "name": "Tutbury & Hatton",
            "value": "TUT"
        },
        {
            "name": "Tweedbank",
            "value": "TWB"
        },
        {
            "name": "Twickenham",
            "value": "TWI"
        },
        {
            "name": "Twyford",
            "value": "TWY"
        },
        {
            "name": "Ty Croes",
            "value": "TYC"
        },
        {
            "name": "Ty Glas",
            "value": "TGS"
        },
        {
            "name": "Tygwyn",
            "value": "TYG"
        },
        {
            "name": "Tyndrum Lower",
            "value": "TYL"
        },
        {
            "name": "Tyseley",
            "value": "TYS"
        },
        {
            "name": "Tywyn",
            "value": "TYW"
        },
        {
            "name": "Uckfield",
            "value": "UCK"
        },
        {
            "name": "Uddingston",
            "value": "UDD"
        },
        {
            "name": "Ulceby",
            "value": "ULC"
        },
        {
            "name": "Ulleskelf",
            "value": "ULL"
        },
        {
            "name": "Ulverston",
            "value": "ULV"
        },
        {
            "name": "Umberleigh",
            "value": "UMB"
        },
        {
            "name": "University (Birmingham)",
            "value": "UNI"
        },
        {
            "name": "Uphall",
            "value": "UHA"
        },
        {
            "name": "Upholland",
            "value": "UPL"
        },
        {
            "name": "Upminster",
            "value": "UPM"
        },
        {
            "name": "Upper Halliford",
            "value": "UPH"
        },
        {
            "name": "Upper Holloway",
            "value": "UHL"
        },
        {
            "name": "Upper Tyndrum",
            "value": "UTY"
        },
        {
            "name": "Upper Warlingham",
            "value": "UWL"
        },
        {
            "name": "Upton (Merseyside)",
            "value": "UPT"
        },
        {
            "name": "Upwey",
            "value": "UPW"
        },
        {
            "name": "Urmston",
            "value": "URM"
        },
        {
            "name": "Uttoxeter",
            "value": "UTT"
        },
        {
            "name": "Valley",
            "value": "VAL"
        },
        {
            "name": "Vauxhall",
            "value": "VXH"
        },
        {
            "name": "Virginia Water",
            "value": "VIR"
        },
        {
            "name": "Waddon",
            "value": "WDO"
        },
        {
            "name": "Wadhurst",
            "value": "WAD"
        },
        {
            "name": "Wainfleet",
            "value": "WFL"
        },
        {
            "name": "Wakefield Kirkgate",
            "value": "WKK"
        },
        {
            "name": "Wakefield Westgate",
            "value": "WKF"
        },
        {
            "name": "Walkden",
            "value": "WKD"
        },
        {
            "name": "Wallasey Grove Road",
            "value": "WLG"
        },
        {
            "name": "Wallasey Village",
            "value": "WLV"
        },
        {
            "name": "Wallington",
            "value": "WLT"
        },
        {
            "name": "Wallyford",
            "value": "WAF"
        },
        {
            "name": "Walmer",
            "value": "WAM"
        },
        {
            "name": "Walsall",
            "value": "WSL"
        },
        {
            "name": "Walsden",
            "value": "WDN"
        },
        {
            "name": "Waltham Cross",
            "value": "WLC"
        },
        {
            "name": "Walthamstow Central",
            "value": "WHC"
        },
        {
            "name": "Walthamstow Queen's Road",
            "value": "WMW"
        },
        {
            "name": "Walton (Merseyside)",
            "value": "WAO"
        },
        {
            "name": "Walton-on-Thames",
            "value": "WAL"
        },
        {
            "name": "Walton-on-the-Naze",
            "value": "WON"
        },
        {
            "name": "Wanborough",
            "value": "WAN"
        },
        {
            "name": "Wandsworth Common",
            "value": "WSW"
        },
        {
            "name": "Wandsworth Road",
            "value": "WWR"
        },
        {
            "name": "Wandsworth Town",
            "value": "WNT"
        },
        {
            "name": "Wanstead Park",
            "value": "WNP"
        },
        {
            "name": "Wapping",
            "value": "WPE"
        },
        {
            "name": "Warblington",
            "value": "WBL"
        },
        {
            "name": "Ware (Herts)",
            "value": "WAR"
        },
        {
            "name": "Wareham (Dorset)",
            "value": "WRM"
        },
        {
            "name": "Wargrave",
            "value": "WGV"
        },
        {
            "name": "Warminster",
            "value": "WMN"
        },
        {
            "name": "Warnham",
            "value": "WNH"
        },
        {
            "name": "Warrington Bank Quay",
            "value": "WBQ"
        },
        {
            "name": "Warrington Central",
            "value": "WAC"
        },
        {
            "name": "Warrington West",
            "value": "WAW"
        },
        {
            "name": "Warwick",
            "value": "WRW"
        },
        {
            "name": "Warwick Parkway",
            "value": "WRP"
        },
        {
            "name": "Water Orton",
            "value": "WTO"
        },
        {
            "name": "Waterbeach",
            "value": "WBC"
        },
        {
            "name": "Wateringbury",
            "value": "WTR"
        },
        {
            "name": "Waterloo (Merseyside)",
            "value": "WLO"
        },
        {
            "name": "Watford High Street",
            "value": "WFH"
        },
        {
            "name": "Watford Junction",
            "value": "WFJ"
        },
        {
            "name": "Watford North",
            "value": "WFN"
        },
        {
            "name": "Watlington",
            "value": "WTG"
        },
        {
            "name": "Watton-at-Stone",
            "value": "WAS"
        },
        {
            "name": "Waun-Gron Park",
            "value": "WNG"
        },
        {
            "name": "Wavertree Technology Park",
            "value": "WAV"
        },
        {
            "name": "Wedgwood",
            "value": "WED"
        },
        {
            "name": "Weeley",
            "value": "WEE"
        },
        {
            "name": "Weeton",
            "value": "WET"
        },
        {
            "name": "Welham Green",
            "value": "WMG"
        },
        {
            "name": "Welling",
            "value": "WLI"
        },
        {
            "name": "Wellingborough",
            "value": "WEL"
        },
        {
            "name": "Wellington (Shropshire)",
            "value": "WLN"
        },
        {
            "name": "Welshpool",
            "value": "WLP"
        },
        {
            "name": "Welwyn Garden City",
            "value": "WGC"
        },
        {
            "name": "Welwyn North",
            "value": "WLW"
        },
        {
            "name": "Wem",
            "value": "WEM"
        },
        {
            "name": "Wembley Central",
            "value": "WMB"
        },
        {
            "name": "Wembley Stadium",
            "value": "WCX"
        },
        {
            "name": "Wemyss Bay",
            "value": "WMS"
        },
        {
            "name": "Wendover",
            "value": "WND"
        },
        {
            "name": "Wennington",
            "value": "WNN"
        },
        {
            "name": "West Allerton",
            "value": "WSA"
        },
        {
            "name": "West Brompton",
            "value": "WBP"
        },
        {
            "name": "West Byfleet",
            "value": "WBY"
        },
        {
            "name": "West Calder",
            "value": "WCL"
        },
        {
            "name": "West Croydon",
            "value": "WCY"
        },
        {
            "name": "West Drayton",
            "value": "WDT"
        },
        {
            "name": "West Dulwich",
            "value": "WDU"
        },
        {
            "name": "West Ealing",
            "value": "WEA"
        },
        {
            "name": "West Ham",
            "value": "WEH"
        },
        {
            "name": "West Hampstead",
            "value": "WHD"
        },
        {
            "name": "West Hampstead Thameslink",
            "value": "WHP"
        },
        {
            "name": "West Horndon",
            "value": "WHR"
        },
        {
            "name": "West Kilbride",
            "value": "WKB"
        },
        {
            "name": "West Kirby",
            "value": "WKI"
        },
        {
            "name": "West Malling",
            "value": "WMA"
        },
        {
            "name": "West Norwood",
            "value": "WNW"
        },
        {
            "name": "West Ruislip",
            "value": "WRU"
        },
        {
            "name": "West Runton",
            "value": "WRN"
        },
        {
            "name": "West St Leonards",
            "value": "WLD"
        },
        {
            "name": "West Sutton",
            "value": "WSU"
        },
        {
            "name": "West Wickham",
            "value": "WWI"
        },
        {
            "name": "West Worthing",
            "value": "WWO"
        },
        {
            "name": "Westbury (Wilts)",
            "value": "WSB"
        },
        {
            "name": "Westcliff",
            "value": "WCF"
        },
        {
            "name": "Westcombe Park",
            "value": "WCB"
        },
        {
            "name": "Westenhanger",
            "value": "WHA"
        },
        {
            "name": "Wester Hailes",
            "value": "WTA"
        },
        {
            "name": "Westerfield",
            "value": "WFI"
        },
        {
            "name": "Westerton",
            "value": "WES"
        },
        {
            "name": "Westgate-on-Sea",
            "value": "WGA"
        },
        {
            "name": "Westhoughton",
            "value": "WHG"
        },
        {
            "name": "Weston Milton",
            "value": "WNM"
        },
        {
            "name": "Weston-super-Mare",
            "value": "WSM"
        },
        {
            "name": "Wetheral",
            "value": "WRL"
        },
        {
            "name": "Weybridge",
            "value": "WYB"
        },
        {
            "name": "Weymouth",
            "value": "WEY"
        },
        {
            "name": "Whaley Bridge",
            "value": "WBR"
        },
        {
            "name": "Whalley (Lancs)",
            "value": "WHE"
        },
        {
            "name": "Whatstandwell",
            "value": "WTS"
        },
        {
            "name": "Whifflet",
            "value": "WFF"
        },
        {
            "name": "Whimple",
            "value": "WHM"
        },
        {
            "name": "Whinhill",
            "value": "WNL"
        },
        {
            "name": "Whiston",
            "value": "WHN"
        },
        {
            "name": "Whitby",
            "value": "WTB"
        },
        {
            "name": "Whitchurch (Cardiff)",
            "value": "WHT"
        },
        {
            "name": "Whitchurch (Hants)",
            "value": "WCH"
        },
        {
            "name": "Whitchurch (Shropshire)",
            "value": "WTC"
        },
        {
            "name": "White Hart Lane",
            "value": "WHL"
        },
        {
            "name": "White Notley",
            "value": "WNY"
        },
        {
            "name": "Whitechapel",
            "value": "ZLW"
        },
        {
            "name": "Whitecraigs",
            "value": "WCR"
        },
        {
            "name": "Whitehaven",
            "value": "WTH"
        },
        {
            "name": "Whitland",
            "value": "WTL"
        },
        {
            "name": "Whitley Bridge",
            "value": "WBD"
        },
        {
            "name": "Whitlocks End",
            "value": "WTE"
        },
        {
            "name": "Whitstable",
            "value": "WHI"
        },
        {
            "name": "Whittlesea",
            "value": "WLE"
        },
        {
            "name": "Whittlesford Parkway",
            "value": "WLF"
        },
        {
            "name": "Whitton (London)",
            "value": "WTN"
        },
        {
            "name": "Whitwell (Derbyshire)",
            "value": "WWL"
        },
        {
            "name": "Whyteleafe",
            "value": "WHY"
        },
        {
            "name": "Whyteleafe South",
            "value": "WHS"
        },
        {
            "name": "Wick",
            "value": "WCK"
        },
        {
            "name": "Wickford",
            "value": "WIC"
        },
        {
            "name": "Wickham Market",
            "value": "WCM"
        },
        {
            "name": "Widdrington",
            "value": "WDD"
        },
        {
            "name": "Widnes",
            "value": "WID"
        },
        {
            "name": "Widney Manor",
            "value": "WMR"
        },
        {
            "name": "Wigan North Western",
            "value": "WGN"
        },
        {
            "name": "Wigan Wallgate",
            "value": "WGW"
        },
        {
            "name": "Wigton",
            "value": "WGT"
        },
        {
            "name": "Wildmill",
            "value": "WMI"
        },
        {
            "name": "Willesden Junction",
            "value": "WIJ"
        },
        {
            "name": "Williamwood",
            "value": "WLM"
        },
        {
            "name": "Willington",
            "value": "WIL"
        },
        {
            "name": "Wilmcote",
            "value": "WMC"
        },
        {
            "name": "Wilmslow",
            "value": "WML"
        },
        {
            "name": "Wilnecote (Staffs)",
            "value": "WNE"
        },
        {
            "name": "Wimbledon",
            "value": "WIM"
        },
        {
            "name": "Wimbledon Chase",
            "value": "WBO"
        },
        {
            "name": "Winchelsea",
            "value": "WSE"
        },
        {
            "name": "Winchester",
            "value": "WIN"
        },
        {
            "name": "Winchfield",
            "value": "WNF"
        },
        {
            "name": "Winchmore Hill",
            "value": "WIH"
        },
        {
            "name": "Windermere",
            "value": "WDM"
        },
        {
            "name": "Windsor & Eton Central",
            "value": "WNC"
        },
        {
            "name": "Windsor & Eton Riverside",
            "value": "WNR"
        },
        {
            "name": "Winnersh",
            "value": "WNS"
        },
        {
            "name": "Winnersh Triangle",
            "value": "WTI"
        },
        {
            "name": "Winsford",
            "value": "WSF"
        },
        {
            "name": "Wishaw",
            "value": "WSH"
        },
        {
            "name": "Witham",
            "value": "WTM"
        },
        {
            "name": "Witley",
            "value": "WTY"
        },
        {
            "name": "Witton (West Midlands)",
            "value": "WTT"
        },
        {
            "name": "Wivelsfield",
            "value": "WVF"
        },
        {
            "name": "Wivenhoe",
            "value": "WIV"
        },
        {
            "name": "Woburn Sands",
            "value": "WOB"
        },
        {
            "name": "Woking",
            "value": "WOK"
        },
        {
            "name": "Wokingham",
            "value": "WKM"
        },
        {
            "name": "Woldingham",
            "value": "WOH"
        },
        {
            "name": "Wolverhampton",
            "value": "WVH"
        },
        {
            "name": "Wolverton",
            "value": "WOL"
        },
        {
            "name": "Wombwell",
            "value": "WOM"
        },
        {
            "name": "Wood End",
            "value": "WDE"
        },
        {
            "name": "Wood Street",
            "value": "WST"
        },
        {
            "name": "Woodbridge",
            "value": "WDB"
        },
        {
            "name": "Woodgrange Park",
            "value": "WGR"
        },
        {
            "name": "Woodhall",
            "value": "WDL"
        },
        {
            "name": "Woodhouse",
            "value": "WDH"
        },
        {
            "name": "Woodlesford",
            "value": "WDS"
        },
        {
            "name": "Woodley",
            "value": "WLY"
        },
        {
            "name": "Woodmansterne",
            "value": "WME"
        },
        {
            "name": "Woodsmoor",
            "value": "WSR"
        },
        {
            "name": "Wool",
            "value": "WOO"
        },
        {
            "name": "Woolston",
            "value": "WLS"
        },
        {
            "name": "Woolwich Arsenal",
            "value": "WWA"
        },
        {
            "name": "Woolwich Dockyard",
            "value": "WWD"
        },
        {
            "name": "Wootton Wawen",
            "value": "WWW"
        },
        {
            "name": "Worcester Foregate Street",
            "value": "WOF"
        },
        {
            "name": "Worcester Park",
            "value": "WCP"
        },
        {
            "name": "Worcester Shrub Hill",
            "value": "WOS"
        },
        {
            "name": "Worcestershire Parkway",
            "value": "WOP"
        },
        {
            "name": "Workington",
            "value": "WKG"
        },
        {
            "name": "Worksop",
            "value": "WRK"
        },
        {
            "name": "Worle",
            "value": "WOR"
        },
        {
            "name": "Worplesdon",
            "value": "WPL"
        },
        {
            "name": "Worstead",
            "value": "WRT"
        },
        {
            "name": "Worthing",
            "value": "WRH"
        },
        {
            "name": "Wrabness",
            "value": "WRB"
        },
        {
            "name": "Wraysbury",
            "value": "WRY"
        },
        {
            "name": "Wrenbury",
            "value": "WRE"
        },
        {
            "name": "Wressle",
            "value": "WRS"
        },
        {
            "name": "Wrexham Central",
            "value": "WXC"
        },
        {
            "name": "Wrexham General",
            "value": "WRX"
        },
        {
            "name": "Wye",
            "value": "WYE"
        },
        {
            "name": "Wylam",
            "value": "WYM"
        },
        {
            "name": "Wylde Green",
            "value": "WYL"
        },
        {
            "name": "Wymondham",
            "value": "WMD"
        },
        {
            "name": "Wythall",
            "value": "WYT"
        },
        {
            "name": "Yalding",
            "value": "YAL"
        },
        {
            "name": "Yardley Wood",
            "value": "YRD"
        },
        {
            "name": "Yarm",
            "value": "YRM"
        },
        {
            "name": "Yate",
            "value": "YAE"
        },
        {
            "name": "Yatton",
            "value": "YAT"
        },
        {
            "name": "Yeoford",
            "value": "YEO"
        },
        {
            "name": "Yeovil Junction",
            "value": "YVJ"
        },
        {
            "name": "Yeovil Pen Mill",
            "value": "YVP"
        },
        {
            "name": "Yetminster",
            "value": "YET"
        },
        {
            "name": "Ynyswen",
            "value": "YNW"
        },
        {
            "name": "Yoker",
            "value": "YOK"
        },
        {
            "name": "York",
            "value": "YRK"
        },
        {
            "name": "Yorton",
            "value": "YRT"
        },
        {
            "name": "Ystrad Mynach",
            "value": "YSM"
        },
        {
            "name": "Ystrad Rhondda",
            "value": "YSR"
        }
    ]


    module.config(['formlyConfigProvider', (formlyConfigProvider) => {
        formlyConfigProvider.setType({
            name: 'trainStationSelect',
            template: `
                <div class="moment-timezone-select" >
                    <md-input-container class="time-zone-autocomplete">
                        <md-autocomplete
                            placeholder="Type your station name"
                            md-selected-item="selectedStation"
                            md-items="station in filtered(searchText)"
                            md-selected-item-change="onStationChange(station)"
                            md-search-text="searchText" 
                            md-item-text="station.name"
                            md-min-length="1"
                            md-select-on-match="true"
                            md-mode="virtual"
                            required
                        >
                            <md-item-template>
                                <span md-highlight-text="searchText" md-highlight-flags="i">{{ station.name }}</span>
                            </md-item-template>
                            <md-not-found>
                                No matches found.
                            </md-not-found>
                        </md-autocomplete>
                    </md-input-container>
                </div>
            `,
            controller: ['$scope', '$q', ($scope, $q) => {
                $scope.to.options = STATIONS;
                const station = $scope.model.station ? $scope.model.station : 'Europe/London';
                $scope.selectedStation = _.find(STATIONS, { value: station });

                $scope.filtered = (query) => {
                    if (!query) return $q.resolve(STATIONS);
                    const regexp = new RegExp(`${query}`, 'i');
                    return $q.resolve(STATIONS.filter(zone => regexp.test(zone.name)));
                };

                $scope.onStationChange = (zone) => {
                    const ZONE_TO_SET = zone ? zone.value : null;
                    _.set($scope, `model.${$scope.options.key}`, ZONE_TO_SET);
                };
            }],
        });
    }]);
})(angular.module('rocket.components'));

